var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;
var _excluded = ["mainAxis", "crossAxis", "fallbackPlacements", "fallbackStrategy", "fallbackAxisSideDirection", "flipAlignment"],
  _excluded2 = ["mainAxis", "crossAxis", "limiter"],
  _excluded3 = ["transform"],
  _excluded4 = ["context", "width", "height", "tipRadius", "strokeWidth", "staticOffset", "stroke", "d", "style"],
  _excluded5 = ["content", "middleware", "children", "strategy", "offset", "arrowOffset", "interactive", "visible", "onOpen", "onClose", "onVisibilityChange", "placement", "maxWidth", "width", "mountNode", "elevation", "flip", "shiftOnOverflow", "arrowProps", "mouseOnly", "showOnInteractions", "followCursor", "virtualElement", "zIndex", "hideOnScroll", "blockPointerEvents", "onHover", "className"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import { jsx as X, jsxs as Ee } from "react/jsx-runtime";
import * as m from "react";
import { useLayoutEffect as Wt, useEffect as me, useRef as ot, Children as Tn, isValidElement as ft, useMemo as rt, useCallback as Sn, forwardRef as Pn, useState as wt, cloneElement as An } from "react";
import { styled as Q, css as be, createGlobalStyle as Ln } from "styled-components";
import * as Vt from "react-dom";
function kn(e) {
  return function (t) {
    e.forEach(function (n) {
      typeof n == "function" ? n(t) : n != null && (n.current = t);
    });
  };
}
function He() {
  return typeof window < "u";
}
function Ht(e) {
  return Yt(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function ve(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Mn(e) {
  var t;
  return (t = (Yt(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Yt(e) {
  return He() ? e instanceof Node || e instanceof ve(e).Node : !1;
}
function j(e) {
  return He() ? e instanceof Element || e instanceof ve(e).Element : !1;
}
function dt(e) {
  return He() ? e instanceof HTMLElement || e instanceof ve(e).HTMLElement : !1;
}
function it(e) {
  return !He() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof ve(e).ShadowRoot;
}
function On() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Ue(e) {
  return ["html", "body", "#document"].includes(Ht(e));
}
function Xt(e) {
  return ve(e).getComputedStyle(e);
}
function In(e) {
  if (Ht(e) === "html") return e;
  var t =
  // Step into the shadow DOM of the parent of a slotted node.
  e.assignedSlot ||
  // DOM Element detected.
  e.parentNode ||
  // ShadowRoot detected.
  it(e) && e.host ||
  // Fallback.
  Mn(e);
  return it(t) ? t.host : t;
}
function st(e) {
  var t = e.activeElement;
  for (; ((n = t) == null || (n = n.shadowRoot) == null ? void 0 : n.activeElement) != null;) {
    var n;
    t = t.shadowRoot.activeElement;
  }
  return t;
}
function re(e, t) {
  if (!e || !t) return !1;
  var n = t.getRootNode == null ? void 0 : t.getRootNode();
  if (e.contains(t)) return !0;
  if (n && it(n)) {
    var o = t;
    for (; o;) {
      if (e === o) return !0;
      o = o.parentNode || o.host;
    }
  }
  return !1;
}
function Dn() {
  var e = navigator.userAgentData;
  return e != null && e.platform ? e.platform : navigator.platform;
}
function jt() {
  return /apple/i.test(navigator.vendor);
}
function Fn() {
  return Dn().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function Ne(e, t) {
  var n = ["mouse", "pen"];
  return n.push("", void 0), n.includes(e);
}
function Nn(e) {
  return "nativeEvent" in e;
}
function $n(e) {
  return e.matches("html,body");
}
function oe(e) {
  return (e == null ? void 0 : e.ownerDocument) || document;
}
function Ke(e, t) {
  if (t == null) return !1;
  if ("composedPath" in e) return e.composedPath().includes(t);
  var n = e;
  return n.target != null && t.contains(n.target);
}
function ue(e) {
  return "composedPath" in e ? e.composedPath()[0] : e.target;
}
var Bn = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function _n(e) {
  return dt(e) && e.matches(Bn);
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var zn = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"],
  ct = /* @__PURE__ */zn.join(","),
  Ut = typeof Element > "u",
  Ce = Ut ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector,
  $e = !Ut && Element.prototype.getRootNode ? function (e) {
    var t;
    return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
  } : function (e) {
    return e == null ? void 0 : e.ownerDocument;
  },
  Be = function e(t, n) {
    var o;
    n === void 0 && (n = !0);
    var r = t == null || (o = t.getAttribute) === null || o === void 0 ? void 0 : o.call(t, "inert"),
      s = r === "" || r === "true",
      i = s || n && t && e(t.parentNode);
    return i;
  },
  Wn = function Wn(t) {
    var n,
      o = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
    return o === "" || o === "true";
  },
  Vn = function Vn(t, n, o) {
    if (Be(t)) return [];
    var r = Array.prototype.slice.apply(t.querySelectorAll(ct));
    return n && Ce.call(t, ct) && r.unshift(t), r = r.filter(o), r;
  },
  Hn = function e(t, n, o) {
    for (var r = [], s = Array.from(t); s.length;) {
      var i = s.shift();
      if (!Be(i, !1)) if (i.tagName === "SLOT") {
        var c = i.assignedElements(),
          l = c.length ? c : i.children,
          u = e(l, !0, o);
        o.flatten ? r.push.apply(r, u) : r.push({
          scopeParent: i,
          candidates: u
        });
      } else {
        var d = Ce.call(i, ct);
        d && o.filter(i) && (n || !t.includes(i)) && r.push(i);
        var f = i.shadowRoot ||
          // check for an undisclosed shadow
          typeof o.getShadowRoot == "function" && o.getShadowRoot(i),
          p = !Be(f, !1) && (!o.shadowRootFilter || o.shadowRootFilter(i));
        if (f && p) {
          var a = e(f === !0 ? i.children : f.children, !0, o);
          o.flatten ? r.push.apply(r, a) : r.push({
            scopeParent: i,
            candidates: a
          });
        } else s.unshift.apply(s, i.children);
      }
    }
    return r;
  },
  Kt = function Kt(t) {
    return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
  },
  qt = function qt(t) {
    if (!t) throw new Error("No node provided");
    return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || Wn(t)) && !Kt(t) ? 0 : t.tabIndex;
  },
  Yn = function Yn(t, n) {
    var o = qt(t);
    return o < 0 && n && !Kt(t) ? 0 : o;
  },
  Xn = function Xn(t, n) {
    return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
  },
  Gt = function Gt(t) {
    return t.tagName === "INPUT";
  },
  jn = function jn(t) {
    return Gt(t) && t.type === "hidden";
  },
  Un = function Un(t) {
    var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function (o) {
      return o.tagName === "SUMMARY";
    });
    return n;
  },
  Kn = function Kn(t, n) {
    for (var o = 0; o < t.length; o++) {
      if (t[o].checked && t[o].form === n) return t[o];
    }
  },
  qn = function qn(t) {
    if (!t.name) return !0;
    var n = t.form || $e(t),
      o = function o(c) {
        return n.querySelectorAll('input[type="radio"][name="' + c + '"]');
      },
      r;
    if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function") r = o(window.CSS.escape(t.name));else try {
      r = o(t.name);
    } catch (i) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", i.message), !1;
    }
    var s = Kn(r, t.form);
    return !s || s === t;
  },
  Gn = function Gn(t) {
    return Gt(t) && t.type === "radio";
  },
  Zn = function Zn(t) {
    return Gn(t) && !qn(t);
  },
  Jn = function Jn(t) {
    var n,
      o = t && $e(t),
      r = (n = o) === null || n === void 0 ? void 0 : n.host,
      s = !1;
    if (o && o !== t) {
      var i, c, l;
      for (s = !!((i = r) !== null && i !== void 0 && (c = i.ownerDocument) !== null && c !== void 0 && c.contains(r) || t != null && (l = t.ownerDocument) !== null && l !== void 0 && l.contains(t)); !s && r;) {
        var u, d, f;
        o = $e(r), r = (u = o) === null || u === void 0 ? void 0 : u.host, s = !!((d = r) !== null && d !== void 0 && (f = d.ownerDocument) !== null && f !== void 0 && f.contains(r));
      }
    }
    return s;
  },
  yt = function yt(t) {
    var n = t.getBoundingClientRect(),
      o = n.width,
      r = n.height;
    return o === 0 && r === 0;
  },
  Qn = function Qn(t, n) {
    var o = n.displayCheck,
      r = n.getShadowRoot;
    if (getComputedStyle(t).visibility === "hidden") return !0;
    var s = Ce.call(t, "details>summary:first-of-type"),
      i = s ? t.parentElement : t;
    if (Ce.call(i, "details:not([open]) *")) return !0;
    if (!o || o === "full" || o === "legacy-full") {
      if (typeof r == "function") {
        for (var c = t; t;) {
          var l = t.parentElement,
            u = $e(t);
          if (l && !l.shadowRoot && r(l) === !0) return yt(t);
          t.assignedSlot ? t = t.assignedSlot : !l && u !== t.ownerDocument ? t = u.host : t = l;
        }
        t = c;
      }
      if (Jn(t)) return !t.getClientRects().length;
      if (o !== "legacy-full") return !0;
    } else if (o === "non-zero-area") return yt(t);
    return !1;
  },
  eo = function eo(t) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName)) for (var n = t.parentElement; n;) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var o = 0; o < n.children.length; o++) {
          var r = n.children.item(o);
          if (r.tagName === "LEGEND") return Ce.call(n, "fieldset[disabled] *") ? !0 : !r.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
    return !1;
  },
  to = function to(t, n) {
    return !(n.disabled ||
    // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    Be(n) || jn(n) || Qn(n, t) ||
    // For a details element with a summary, the summary element gets the focus
    Un(n) || eo(n));
  },
  xt = function xt(t, n) {
    return !(Zn(n) || qt(n) < 0 || !to(t, n));
  },
  no = function no(t) {
    var n = parseInt(t.getAttribute("tabindex"), 10);
    return !!(isNaN(n) || n >= 0);
  },
  oo = function e(t) {
    var n = [],
      o = [];
    return t.forEach(function (r, s) {
      var i = !!r.scopeParent,
        c = i ? r.scopeParent : r,
        l = Yn(c, i),
        u = i ? e(r.candidates) : c;
      l === 0 ? i ? n.push.apply(n, u) : n.push(c) : o.push({
        documentOrder: s,
        tabIndex: l,
        item: r,
        isScope: i,
        content: u
      });
    }), o.sort(Xn).reduce(function (r, s) {
      return s.isScope ? r.push.apply(r, s.content) : r.push(s.content), r;
    }, []).concat(n);
  },
  Zt = function Zt(t, n) {
    n = n || {};
    var o;
    return n.getShadowRoot ? o = Hn([t], n.includeContainer, {
      filter: xt.bind(null, n),
      flatten: !1,
      getShadowRoot: n.getShadowRoot,
      shadowRootFilter: no
    }) : o = Vn(t, n.includeContainer, xt.bind(null, n)), oo(o);
  };
var ye = Math.min,
  pe = Math.max,
  _e = Math.round,
  Oe = Math.floor,
  fe = function fe(e) {
    return {
      x: e,
      y: e
    };
  },
  ro = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
  },
  io = {
    start: "end",
    end: "start"
  };
function lt(e, t, n) {
  return pe(e, ye(t, n));
}
function Se(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ge(e) {
  return e.split("-")[0];
}
function Pe(e) {
  return e.split("-")[1];
}
function Jt(e) {
  return e === "x" ? "y" : "x";
}
function mt(e) {
  return e === "y" ? "height" : "width";
}
function Ye(e) {
  return ["top", "bottom"].includes(ge(e)) ? "y" : "x";
}
function pt(e) {
  return Jt(Ye(e));
}
function so(e, t, n) {
  n === void 0 && (n = !1);
  var o = Pe(e),
    r = pt(e),
    s = mt(r);
  var i = r === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[s] > t.floating[s] && (i = ze(i)), [i, ze(i)];
}
function co(e) {
  var t = ze(e);
  return [ut(e), t, ut(t)];
}
function ut(e) {
  return e.replace(/start|end/g, function (t) {
    return io[t];
  });
}
function lo(e, t, n) {
  var o = ["left", "right"],
    r = ["right", "left"],
    s = ["top", "bottom"],
    i = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? r : o : t ? o : r;
    case "left":
    case "right":
      return t ? s : i;
    default:
      return [];
  }
}
function uo(e, t, n, o) {
  var r = Pe(e);
  var s = lo(ge(e), n === "start", o);
  return r && (s = s.map(function (i) {
    return i + "-" + r;
  }), t && (s = s.concat(s.map(ut)))), s;
}
function ze(e) {
  return e.replace(/left|right|bottom|top/g, function (t) {
    return ro[t];
  });
}
function ao(e) {
  return _objectSpread({
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }, e);
}
function Qt(e) {
  return typeof e != "number" ? ao(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function We(e) {
  return _objectSpread(_objectSpread({}, e), {}, {
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function Rt(e, t, n) {
  var o = e.reference,
    r = e.floating;
  var s = Ye(t),
    i = pt(t),
    c = mt(i),
    l = ge(t),
    u = s === "y",
    d = o.x + o.width / 2 - r.width / 2,
    f = o.y + o.height / 2 - r.height / 2,
    p = o[c] / 2 - r[c] / 2;
  var a;
  switch (l) {
    case "top":
      a = {
        x: d,
        y: o.y - r.height
      };
      break;
    case "bottom":
      a = {
        x: d,
        y: o.y + o.height
      };
      break;
    case "right":
      a = {
        x: o.x + o.width,
        y: f
      };
      break;
    case "left":
      a = {
        x: o.x - r.width,
        y: f
      };
      break;
    default:
      a = {
        x: o.x,
        y: o.y
      };
  }
  switch (Pe(t)) {
    case "start":
      a[i] -= p * (n && u ? -1 : 1);
      break;
    case "end":
      a[i] += p * (n && u ? -1 : 1);
      break;
  }
  return a;
}
var fo = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e, t, n) {
    var _n$placement, o, _n$strategy, r, _n$middleware, s, i, c, l, u, _Rt, d, f, p, a, h, g, _Rt2, _c$g, v, w, _yield$w, y, R, S, A;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _n$placement = n.placement;
            o = _n$placement === void 0 ? "bottom" : _n$placement;
            _n$strategy = n.strategy;
            r = _n$strategy === void 0 ? "absolute" : _n$strategy;
            _n$middleware = n.middleware;
            s = _n$middleware === void 0 ? [] : _n$middleware;
            i = n.platform;
            c = s.filter(Boolean);
            _context.next = 10;
            return i.isRTL == null ? void 0 : i.isRTL(t);
          case 10:
            l = _context.sent;
            _context.next = 13;
            return i.getElementRects({
              reference: e,
              floating: t,
              strategy: r
            });
          case 13:
            u = _context.sent;
            _Rt = Rt(u, o, l);
            d = _Rt.x;
            f = _Rt.y;
            p = o;
            a = {};
            h = 0;
            g = 0;
          case 21:
            if (!(g < c.length)) {
              _context.next = 56;
              break;
            }
            _c$g = c[g];
            v = _c$g.name;
            w = _c$g.fn;
            _context.next = 27;
            return w({
              x: d,
              y: f,
              initialPlacement: o,
              placement: p,
              strategy: r,
              middlewareData: a,
              rects: u,
              platform: i,
              elements: {
                reference: e,
                floating: t
              }
            });
          case 27:
            _yield$w = _context.sent;
            y = _yield$w.x;
            R = _yield$w.y;
            S = _yield$w.data;
            A = _yield$w.reset;
            d = y !== null && y !== void 0 ? y : d;
            f = R !== null && R !== void 0 ? R : f;
            a = _objectSpread(_objectSpread({}, a), {}, {
              [v]: _objectSpread(_objectSpread({}, a[v]), S)
            });
            _context.t0 = A && h <= 50;
            if (!_context.t0) {
              _context.next = 53;
              break;
            }
            h++;
            _context.t1 = typeof A == "object";
            if (!_context.t1) {
              _context.next = 52;
              break;
            }
            A.placement && (p = A.placement);
            _context.t2 = A.rects;
            if (!_context.t2) {
              _context.next = 51;
              break;
            }
            if (!(A.rects === !0)) {
              _context.next = 49;
              break;
            }
            _context.next = 46;
            return i.getElementRects({
              reference: e,
              floating: t,
              strategy: r
            });
          case 46:
            _context.t3 = _context.sent;
            _context.next = 50;
            break;
          case 49:
            _context.t3 = A.rects;
          case 50:
            u = _context.t3;
          case 51:
            _Rt2 = Rt(u, p, l), d = _Rt2.x, f = _Rt2.y;
          case 52:
            g = -1;
          case 53:
            g++;
            _context.next = 21;
            break;
          case 56:
            return _context.abrupt("return", {
              x: d,
              y: f,
              placement: p,
              strategy: r,
              middlewareData: a
            });
          case 57:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function fo(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
function en(_x4, _x5) {
  return _en.apply(this, arguments);
}
function _en() {
  _en = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(e, t) {
    var n, o, r, s, i, c, l, _Se3, _Se3$boundary, u, _Se3$rootBoundary, d, _Se3$elementContext, f, _Se3$altBoundary, p, _Se3$padding, a, h, v, w, y, R, S, A;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            t === void 0 && (t = {});
            o = e.x;
            r = e.y;
            s = e.platform;
            i = e.rects;
            c = e.elements;
            l = e.strategy;
            _Se3 = Se(t, e);
            _Se3$boundary = _Se3.boundary;
            u = _Se3$boundary === void 0 ? "clippingAncestors" : _Se3$boundary;
            _Se3$rootBoundary = _Se3.rootBoundary;
            d = _Se3$rootBoundary === void 0 ? "viewport" : _Se3$rootBoundary;
            _Se3$elementContext = _Se3.elementContext;
            f = _Se3$elementContext === void 0 ? "floating" : _Se3$elementContext;
            _Se3$altBoundary = _Se3.altBoundary;
            p = _Se3$altBoundary === void 0 ? !1 : _Se3$altBoundary;
            _Se3$padding = _Se3.padding;
            a = _Se3$padding === void 0 ? 0 : _Se3$padding;
            h = Qt(a);
            v = c[p ? f === "floating" ? "reference" : "floating" : f];
            _context7.t0 = We;
            _context7.t1 = s;
            _context7.next = 24;
            return s.isElement == null ? void 0 : s.isElement(v);
          case 24:
            _context7.t3 = n = _context7.sent;
            _context7.t2 = _context7.t3 == null;
            if (_context7.t2) {
              _context7.next = 28;
              break;
            }
            _context7.t2 = n;
          case 28:
            if (!_context7.t2) {
              _context7.next = 32;
              break;
            }
            _context7.t4 = v;
            _context7.next = 38;
            break;
          case 32:
            _context7.t5 = v.contextElement;
            if (_context7.t5) {
              _context7.next = 37;
              break;
            }
            _context7.next = 36;
            return s.getDocumentElement == null ? void 0 : s.getDocumentElement(c.floating);
          case 36:
            _context7.t5 = _context7.sent;
          case 37:
            _context7.t4 = _context7.t5;
          case 38:
            _context7.t6 = _context7.t4;
            _context7.t7 = u;
            _context7.t8 = d;
            _context7.t9 = l;
            _context7.t10 = {
              element: _context7.t6,
              boundary: _context7.t7,
              rootBoundary: _context7.t8,
              strategy: _context7.t9
            };
            _context7.next = 45;
            return _context7.t1.getClippingRect.call(_context7.t1, _context7.t10);
          case 45:
            _context7.t11 = _context7.sent;
            w = (0, _context7.t0)(_context7.t11);
            y = f === "floating" ? _objectSpread(_objectSpread({}, i.floating), {}, {
              x: o,
              y: r
            }) : i.reference;
            _context7.next = 50;
            return s.getOffsetParent == null ? void 0 : s.getOffsetParent(c.floating);
          case 50:
            R = _context7.sent;
            _context7.next = 53;
            return s.isElement == null ? void 0 : s.isElement(R);
          case 53:
            if (!_context7.sent) {
              _context7.next = 62;
              break;
            }
            _context7.next = 56;
            return s.getScale == null ? void 0 : s.getScale(R);
          case 56:
            _context7.t13 = _context7.sent;
            if (_context7.t13) {
              _context7.next = 59;
              break;
            }
            _context7.t13 = {
              x: 1,
              y: 1
            };
          case 59:
            _context7.t12 = _context7.t13;
            _context7.next = 63;
            break;
          case 62:
            _context7.t12 = {
              x: 1,
              y: 1
            };
          case 63:
            S = _context7.t12;
            _context7.t14 = We;
            if (!s.convertOffsetParentRelativeRectToViewportRelativeRect) {
              _context7.next = 71;
              break;
            }
            _context7.next = 68;
            return s.convertOffsetParentRelativeRectToViewportRelativeRect({
              elements: c,
              rect: y,
              offsetParent: R,
              strategy: l
            });
          case 68:
            _context7.t15 = _context7.sent;
            _context7.next = 72;
            break;
          case 71:
            _context7.t15 = y;
          case 72:
            _context7.t16 = _context7.t15;
            A = (0, _context7.t14)(_context7.t16);
            return _context7.abrupt("return", {
              top: (w.top - A.top + h.top) / S.y,
              bottom: (A.bottom - w.bottom + h.bottom) / S.y,
              left: (w.left - A.left + h.left) / S.x,
              right: (A.right - w.right + h.right) / S.x
            });
          case 75:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _en.apply(this, arguments);
}
var mo = function mo(e) {
    return {
      name: "arrow",
      options: e,
      fn(t) {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          var n, o, r, s, i, c, l, _ref2, u, _ref2$padding, d, f, p, a, h, g, v, w, y, R, S, A, P, M, D, B, _, V, F, O, b, E, k, C;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  n = t.x, o = t.y, r = t.placement, s = t.rects, i = t.platform, c = t.elements, l = t.middlewareData, _ref2 = Se(e, t) || {}, u = _ref2.element, _ref2$padding = _ref2.padding, d = _ref2$padding === void 0 ? 0 : _ref2$padding;
                  if (!(u == null)) {
                    _context2.next = 3;
                    break;
                  }
                  return _context2.abrupt("return", {});
                case 3:
                  f = Qt(d);
                  p = {
                    x: n,
                    y: o
                  };
                  a = pt(r);
                  h = mt(a);
                  _context2.next = 9;
                  return i.getDimensions(u);
                case 9:
                  g = _context2.sent;
                  v = a === "y";
                  w = v ? "top" : "left";
                  y = v ? "bottom" : "right";
                  R = v ? "clientHeight" : "clientWidth";
                  S = s.reference[h] + s.reference[a] - p[a] - s.floating[h];
                  A = p[a] - s.reference[a];
                  _context2.next = 18;
                  return i.getOffsetParent == null ? void 0 : i.getOffsetParent(u);
                case 18:
                  P = _context2.sent;
                  M = P ? P[R] : 0;
                  _context2.t0 = !M;
                  if (_context2.t0) {
                    _context2.next = 25;
                    break;
                  }
                  _context2.next = 24;
                  return i.isElement == null ? void 0 : i.isElement(P);
                case 24:
                  _context2.t0 = !_context2.sent;
                case 25:
                  _context2.t1 = _context2.t0;
                  if (!_context2.t1) {
                    _context2.next = 28;
                    break;
                  }
                  M = c.floating[R] || s.floating[h];
                case 28:
                  D = S / 2 - A / 2, B = M / 2 - g[h] / 2 - 1, _ = ye(f[w], B), V = ye(f[y], B), F = _, O = M - g[h] - V, b = M / 2 - g[h] / 2 + D, E = lt(F, b, O), k = !l.arrow && Pe(r) != null && b !== E && s.reference[h] / 2 - (b < F ? _ : V) - g[h] / 2 < 0, C = k ? b < F ? b - F : b - O : 0;
                  return _context2.abrupt("return", {
                    [a]: p[a] + C,
                    data: _objectSpread({
                      [a]: E,
                      centerOffset: b - E - C
                    }, k && {
                      alignmentOffset: C
                    }),
                    reset: k
                  });
                case 30:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))();
      }
    };
  },
  po = function po(e) {
    return e === void 0 && (e = {}), {
      name: "flip",
      options: e,
      fn(t) {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
          var n, o, r, s, i, c, l, u, _Se, _Se$mainAxis, d, _Se$crossAxis, f, p, _Se$fallbackStrategy, a, _Se$fallbackAxisSideD, h, _Se$flipAlignment, g, v, w, y, R, S, A, P, M, D, F, B, _, _F, O, b, V, E;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  r = t.placement, s = t.middlewareData, i = t.rects, c = t.initialPlacement, l = t.platform, u = t.elements, _Se = Se(e, t), _Se$mainAxis = _Se.mainAxis, d = _Se$mainAxis === void 0 ? !0 : _Se$mainAxis, _Se$crossAxis = _Se.crossAxis, f = _Se$crossAxis === void 0 ? !0 : _Se$crossAxis, p = _Se.fallbackPlacements, _Se$fallbackStrategy = _Se.fallbackStrategy, a = _Se$fallbackStrategy === void 0 ? "bestFit" : _Se$fallbackStrategy, _Se$fallbackAxisSideD = _Se.fallbackAxisSideDirection, h = _Se$fallbackAxisSideD === void 0 ? "none" : _Se$fallbackAxisSideD, _Se$flipAlignment = _Se.flipAlignment, g = _Se$flipAlignment === void 0 ? !0 : _Se$flipAlignment, v = _objectWithoutProperties(_Se, _excluded);
                  if (!((n = s.arrow) != null && n.alignmentOffset)) {
                    _context3.next = 3;
                    break;
                  }
                  return _context3.abrupt("return", {});
                case 3:
                  w = ge(r);
                  y = ge(c) === c;
                  _context3.next = 7;
                  return l.isRTL == null ? void 0 : l.isRTL(u.floating);
                case 7:
                  R = _context3.sent;
                  S = p || (y || !g ? [ze(c)] : co(c));
                  !p && h !== "none" && S.push.apply(S, _toConsumableArray(uo(c, g, h, R)));
                  A = [c].concat(_toConsumableArray(S));
                  _context3.next = 13;
                  return en(t, v);
                case 13:
                  P = _context3.sent;
                  M = [];
                  D = ((o = s.flip) == null ? void 0 : o.overflows) || [];
                  if (d && M.push(P[w]), f) {
                    F = so(r, i, R);
                    M.push(P[F[0]], P[F[1]]);
                  }
                  if (!(D = [].concat(_toConsumableArray(D), [{
                    placement: r,
                    overflows: M
                  }]), !M.every(function (F) {
                    return F <= 0;
                  }))) {
                    _context3.next = 33;
                    break;
                  }
                  _F = (((B = s.flip) == null ? void 0 : B.index) || 0) + 1, O = A[_F];
                  if (!O) {
                    _context3.next = 21;
                    break;
                  }
                  return _context3.abrupt("return", {
                    data: {
                      index: _F,
                      overflows: D
                    },
                    reset: {
                      placement: O
                    }
                  });
                case 21:
                  b = (_ = D.filter(function (E) {
                    return E.overflows[0] <= 0;
                  }).sort(function (E, k) {
                    return E.overflows[1] - k.overflows[1];
                  })[0]) == null ? void 0 : _.placement;
                  if (b) {
                    _context3.next = 31;
                    break;
                  }
                  _context3.t0 = a;
                  _context3.next = _context3.t0 === "bestFit" ? 26 : _context3.t0 === "initialPlacement" ? 29 : 31;
                  break;
                case 26:
                  E = (V = D.map(function (k) {
                    return [k.placement, k.overflows.filter(function (C) {
                      return C > 0;
                    }).reduce(function (C, T) {
                      return C + T;
                    }, 0)];
                  }).sort(function (k, C) {
                    return k[1] - C[1];
                  })[0]) == null ? void 0 : V[0];
                  E && (b = E);
                  return _context3.abrupt("break", 31);
                case 29:
                  b = c;
                  return _context3.abrupt("break", 31);
                case 31:
                  if (!(r !== b)) {
                    _context3.next = 33;
                    break;
                  }
                  return _context3.abrupt("return", {
                    reset: {
                      placement: b
                    }
                  });
                case 33:
                  return _context3.abrupt("return", {});
                case 34:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }))();
      }
    };
  };
function go(_x6, _x7) {
  return _go.apply(this, arguments);
}
function _go() {
  _go = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(e, t) {
    var n, o, r, s, i, c, l, u, d, f, _ref22, p, a, h;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            n = e.placement;
            o = e.platform;
            r = e.elements;
            _context8.next = 5;
            return o.isRTL == null ? void 0 : o.isRTL(r.floating);
          case 5:
            s = _context8.sent;
            i = ge(n);
            c = Pe(n);
            l = Ye(n) === "y";
            u = ["left", "top"].includes(i) ? -1 : 1;
            d = s && l ? -1 : 1;
            f = Se(t, e);
            _ref22 = typeof f == "number" ? {
              mainAxis: f,
              crossAxis: 0,
              alignmentAxis: null
            } : _objectSpread({
              mainAxis: 0,
              crossAxis: 0,
              alignmentAxis: null
            }, f), p = _ref22.mainAxis, a = _ref22.crossAxis, h = _ref22.alignmentAxis;
            return _context8.abrupt("return", (c && typeof h == "number" && (a = c === "end" ? h * -1 : h), l ? {
              x: a * d,
              y: p * u
            } : {
              x: p * u,
              y: a * d
            }));
          case 14:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _go.apply(this, arguments);
}
var ho = function ho(e) {
    return e === void 0 && (e = 0), {
      name: "offset",
      options: e,
      fn(t) {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
          var n, o, r, s, i, c, l;
          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  r = t.x;
                  s = t.y;
                  i = t.placement;
                  c = t.middlewareData;
                  _context4.next = 6;
                  return go(t, e);
                case 6:
                  l = _context4.sent;
                  return _context4.abrupt("return", i === ((n = c.offset) == null ? void 0 : n.placement) && (o = c.arrow) != null && o.alignmentOffset ? {} : {
                    x: r + l.x,
                    y: s + l.y,
                    data: _objectSpread(_objectSpread({}, l), {}, {
                      placement: i
                    })
                  });
                case 8:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }))();
      }
    };
  },
  bo = function bo(e) {
    return e === void 0 && (e = {}), {
      name: "shift",
      options: e,
      fn(t) {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
          var n, o, r, _Se2, _Se2$mainAxis, s, _Se2$crossAxis, i, _Se2$limiter, c, l, u, d, f, p, a, h, v, w, y, R, _v, _w, _y, _R, g;
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  n = t.x;
                  o = t.y;
                  r = t.placement;
                  _Se2 = Se(e, t);
                  _Se2$mainAxis = _Se2.mainAxis;
                  s = _Se2$mainAxis === void 0 ? !0 : _Se2$mainAxis;
                  _Se2$crossAxis = _Se2.crossAxis;
                  i = _Se2$crossAxis === void 0 ? !1 : _Se2$crossAxis;
                  _Se2$limiter = _Se2.limiter;
                  c = _Se2$limiter === void 0 ? {
                    fn: function fn(v) {
                      var w = v.x,
                        y = v.y;
                      return {
                        x: w,
                        y
                      };
                    }
                  } : _Se2$limiter;
                  l = _objectWithoutProperties(_Se2, _excluded2);
                  u = {
                    x: n,
                    y: o
                  };
                  _context5.next = 14;
                  return en(t, l);
                case 14:
                  d = _context5.sent;
                  f = Ye(ge(r));
                  p = Jt(f);
                  a = u[p], h = u[f];
                  if (s) {
                    v = p === "y" ? "top" : "left", w = p === "y" ? "bottom" : "right", y = a + d[v], R = a - d[w];
                    a = lt(y, a, R);
                  }
                  if (i) {
                    _v = f === "y" ? "top" : "left", _w = f === "y" ? "bottom" : "right", _y = h + d[_v], _R = h - d[_w];
                    h = lt(_y, h, _R);
                  }
                  g = c.fn(_objectSpread(_objectSpread({}, t), {}, {
                    [p]: a,
                    [f]: h
                  }));
                  return _context5.abrupt("return", _objectSpread(_objectSpread({}, g), {}, {
                    data: {
                      x: g.x - n,
                      y: g.y - o
                    }
                  }));
                case 22:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }))();
      }
    };
  };
function Re(e) {
  return tn(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function K(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function ce(e) {
  var t;
  return (t = (tn(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function tn(e) {
  return e instanceof Node || e instanceof K(e).Node;
}
function ie(e) {
  return e instanceof Element || e instanceof K(e).Element;
}
function se(e) {
  return e instanceof HTMLElement || e instanceof K(e).HTMLElement;
}
function Et(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof K(e).ShadowRoot;
}
function Ae(e) {
  var _ne = ne(e),
    t = _ne.overflow,
    n = _ne.overflowX,
    o = _ne.overflowY,
    r = _ne.display;
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && !["inline", "contents"].includes(r);
}
function vo(e) {
  return ["table", "td", "th"].includes(Re(e));
}
function gt(e) {
  var t = ht(),
    n = ne(e);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some(function (o) {
    return (n.willChange || "").includes(o);
  }) || ["paint", "layout", "strict", "content"].some(function (o) {
    return (n.contain || "").includes(o);
  });
}
function wo(e) {
  var t = de(e);
  for (; se(t) && !xe(t);) {
    if (gt(t)) return t;
    t = de(t);
  }
  return null;
}
function ht() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function xe(e) {
  return ["html", "body", "#document"].includes(Re(e));
}
function ne(e) {
  return K(e).getComputedStyle(e);
}
function Xe(e) {
  return ie(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function de(e) {
  if (Re(e) === "html") return e;
  var t =
  // Step into the shadow DOM of the parent of a slotted node.
  e.assignedSlot ||
  // DOM Element detected.
  e.parentNode ||
  // ShadowRoot detected.
  Et(e) && e.host ||
  // Fallback.
  ce(e);
  return Et(t) ? t.host : t;
}
function nn(e) {
  var t = de(e);
  return xe(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : se(t) && Ae(t) ? t : nn(t);
}
function ae(e, t, n) {
  var o;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  var r = nn(e),
    s = r === ((o = e.ownerDocument) == null ? void 0 : o.body),
    i = K(r);
  return s ? t.concat(i, i.visualViewport || [], Ae(r) ? r : [], i.frameElement && n ? ae(i.frameElement) : []) : t.concat(r, ae(r, [], n));
}
function on(e) {
  var t = ne(e);
  var n = parseFloat(t.width) || 0,
    o = parseFloat(t.height) || 0;
  var r = se(e),
    s = r ? e.offsetWidth : n,
    i = r ? e.offsetHeight : o,
    c = _e(n) !== s || _e(o) !== i;
  return c && (n = s, o = i), {
    width: n,
    height: o,
    $: c
  };
}
function bt(e) {
  return ie(e) ? e : e.contextElement;
}
function we(e) {
  var t = bt(e);
  if (!se(t)) return fe(1);
  var n = t.getBoundingClientRect(),
    _on = on(t),
    o = _on.width,
    r = _on.height,
    s = _on.$;
  var i = (s ? _e(n.width) : n.width) / o,
    c = (s ? _e(n.height) : n.height) / r;
  return (!i || !Number.isFinite(i)) && (i = 1), (!c || !Number.isFinite(c)) && (c = 1), {
    x: i,
    y: c
  };
}
var yo = /* @__PURE__ */fe(0);
function rn(e) {
  var t = K(e);
  return !ht() || !t.visualViewport ? yo : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function xo(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== K(e) ? !1 : t;
}
function he(e, t, n, o) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(),
    s = bt(e);
  var i = fe(1);
  t && (o ? ie(o) && (i = we(o)) : i = we(e));
  var c = xo(s, n, o) ? rn(s) : fe(0);
  var l = (r.left + c.x) / i.x,
    u = (r.top + c.y) / i.y,
    d = r.width / i.x,
    f = r.height / i.y;
  if (s) {
    var p = K(s),
      a = o && ie(o) ? K(o) : o;
    var h = p,
      g = h.frameElement;
    for (; g && o && a !== h;) {
      var v = we(g),
        w = g.getBoundingClientRect(),
        y = ne(g),
        R = w.left + (g.clientLeft + parseFloat(y.paddingLeft)) * v.x,
        S = w.top + (g.clientTop + parseFloat(y.paddingTop)) * v.y;
      l *= v.x, u *= v.y, d *= v.x, f *= v.y, l += R, u += S, h = K(g), g = h.frameElement;
    }
  }
  return We({
    width: d,
    height: f,
    x: l,
    y: u
  });
}
var Ro = [":popover-open", ":modal"];
function vt(e) {
  return Ro.some(function (t) {
    try {
      return e.matches(t);
    } catch (_unused) {
      return !1;
    }
  });
}
function Eo(e) {
  var t = e.elements,
    n = e.rect,
    o = e.offsetParent,
    r = e.strategy;
  var s = r === "fixed",
    i = ce(o),
    c = t ? vt(t.floating) : !1;
  if (o === i || c && s) return n;
  var l = {
      scrollLeft: 0,
      scrollTop: 0
    },
    u = fe(1);
  var d = fe(0),
    f = se(o);
  if ((f || !f && !s) && ((Re(o) !== "body" || Ae(i)) && (l = Xe(o)), se(o))) {
    var p = he(o);
    u = we(o), d.x = p.x + o.clientLeft, d.y = p.y + o.clientTop;
  }
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - l.scrollLeft * u.x + d.x,
    y: n.y * u.y - l.scrollTop * u.y + d.y
  };
}
function Co(e) {
  return Array.from(e.getClientRects());
}
function sn(e) {
  return he(ce(e)).left + Xe(e).scrollLeft;
}
function To(e) {
  var t = ce(e),
    n = Xe(e),
    o = e.ownerDocument.body,
    r = pe(t.scrollWidth, t.clientWidth, o.scrollWidth, o.clientWidth),
    s = pe(t.scrollHeight, t.clientHeight, o.scrollHeight, o.clientHeight);
  var i = -n.scrollLeft + sn(e);
  var c = -n.scrollTop;
  return ne(o).direction === "rtl" && (i += pe(t.clientWidth, o.clientWidth) - r), {
    width: r,
    height: s,
    x: i,
    y: c
  };
}
function So(e, t) {
  var n = K(e),
    o = ce(e),
    r = n.visualViewport;
  var s = o.clientWidth,
    i = o.clientHeight,
    c = 0,
    l = 0;
  if (r) {
    s = r.width, i = r.height;
    var u = ht();
    (!u || u && t === "fixed") && (c = r.offsetLeft, l = r.offsetTop);
  }
  return {
    width: s,
    height: i,
    x: c,
    y: l
  };
}
function Po(e, t) {
  var n = he(e, !0, t === "fixed"),
    o = n.top + e.clientTop,
    r = n.left + e.clientLeft,
    s = se(e) ? we(e) : fe(1),
    i = e.clientWidth * s.x,
    c = e.clientHeight * s.y,
    l = r * s.x,
    u = o * s.y;
  return {
    width: i,
    height: c,
    x: l,
    y: u
  };
}
function Ct(e, t, n) {
  var o;
  if (t === "viewport") o = So(e, n);else if (t === "document") o = To(ce(e));else if (ie(t)) o = Po(t, n);else {
    var r = rn(e);
    o = _objectSpread(_objectSpread({}, t), {}, {
      x: t.x - r.x,
      y: t.y - r.y
    });
  }
  return We(o);
}
function cn(e, t) {
  var n = de(e);
  return n === t || !ie(n) || xe(n) ? !1 : ne(n).position === "fixed" || cn(n, t);
}
function Ao(e, t) {
  var n = t.get(e);
  if (n) return n;
  var o = ae(e, [], !1).filter(function (c) {
      return ie(c) && Re(c) !== "body";
    }),
    r = null;
  var s = ne(e).position === "fixed";
  var i = s ? de(e) : e;
  for (; ie(i) && !xe(i);) {
    var c = ne(i),
      l = gt(i);
    !l && c.position === "fixed" && (r = null), (s ? !l && !r : !l && c.position === "static" && !!r && ["absolute", "fixed"].includes(r.position) || Ae(i) && !l && cn(e, i)) ? o = o.filter(function (d) {
      return d !== i;
    }) : r = c, i = de(i);
  }
  return t.set(e, o), o;
}
function Lo(e) {
  var t = e.element,
    n = e.boundary,
    o = e.rootBoundary,
    r = e.strategy;
  var i = [].concat(_toConsumableArray(n === "clippingAncestors" ? vt(t) ? [] : Ao(t, this._c) : [].concat(n)), [o]),
    c = i[0],
    l = i.reduce(function (u, d) {
      var f = Ct(t, d, r);
      return u.top = pe(f.top, u.top), u.right = ye(f.right, u.right), u.bottom = ye(f.bottom, u.bottom), u.left = pe(f.left, u.left), u;
    }, Ct(t, c, r));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function ko(e) {
  var _on2 = on(e),
    t = _on2.width,
    n = _on2.height;
  return {
    width: t,
    height: n
  };
}
function Mo(e, t, n) {
  var o = se(t),
    r = ce(t),
    s = n === "fixed",
    i = he(e, !0, s, t);
  var c = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var l = fe(0);
  if (o || !o && !s) if ((Re(t) !== "body" || Ae(r)) && (c = Xe(t)), o) {
    var f = he(t, !0, s, t);
    l.x = f.x + t.clientLeft, l.y = f.y + t.clientTop;
  } else r && (l.x = sn(r));
  var u = i.left + c.scrollLeft - l.x,
    d = i.top + c.scrollTop - l.y;
  return {
    x: u,
    y: d,
    width: i.width,
    height: i.height
  };
}
function qe(e) {
  return ne(e).position === "static";
}
function Tt(e, t) {
  return !se(e) || ne(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function ln(e, t) {
  var n = K(e);
  if (vt(e)) return n;
  if (!se(e)) {
    var r = de(e);
    for (; r && !xe(r);) {
      if (ie(r) && !qe(r)) return r;
      r = de(r);
    }
    return n;
  }
  var o = Tt(e, t);
  for (; o && vo(o) && qe(o);) {
    o = Tt(o, t);
  }
  return o && xe(o) && qe(o) && !gt(o) ? n : o || wo(e) || n;
}
var Oo = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(e) {
    var t, n, o;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            t = this.getOffsetParent || ln;
            n = this.getDimensions;
            _context6.next = 4;
            return n(e.floating);
          case 4:
            o = _context6.sent;
            _context6.t0 = Mo;
            _context6.t1 = e.reference;
            _context6.next = 9;
            return t(e.floating);
          case 9:
            _context6.t2 = _context6.sent;
            _context6.t3 = e.strategy;
            _context6.t4 = (0, _context6.t0)(_context6.t1, _context6.t2, _context6.t3);
            _context6.t5 = {
              x: 0,
              y: 0,
              width: o.width,
              height: o.height
            };
            return _context6.abrupt("return", {
              reference: _context6.t4,
              floating: _context6.t5
            });
          case 14:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));
  return function Oo(_x8) {
    return _ref3.apply(this, arguments);
  };
}();
function Io(e) {
  return ne(e).direction === "rtl";
}
var Do = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Eo,
  getDocumentElement: ce,
  getClippingRect: Lo,
  getOffsetParent: ln,
  getElementRects: Oo,
  getClientRects: Co,
  getDimensions: ko,
  getScale: we,
  isElement: ie,
  isRTL: Io
};
function Fo(e, t) {
  var n = null,
    o;
  var r = ce(e);
  function s() {
    var c;
    clearTimeout(o), (c = n) == null || c.disconnect(), n = null;
  }
  function i(c, l) {
    c === void 0 && (c = !1), l === void 0 && (l = 1), s();
    var _e$getBoundingClientR = e.getBoundingClientRect(),
      u = _e$getBoundingClientR.left,
      d = _e$getBoundingClientR.top,
      f = _e$getBoundingClientR.width,
      p = _e$getBoundingClientR.height;
    if (c || t(), !f || !p) return;
    var a = Oe(d),
      h = Oe(r.clientWidth - (u + f)),
      g = Oe(r.clientHeight - (d + p)),
      v = Oe(u),
      y = {
        rootMargin: -a + "px " + -h + "px " + -g + "px " + -v + "px",
        threshold: pe(0, ye(1, l)) || 1
      };
    var R = !0;
    function S(A) {
      var P = A[0].intersectionRatio;
      if (P !== l) {
        if (!R) return i();
        P ? i(!1, P) : o = setTimeout(function () {
          i(!1, 1e-7);
        }, 1e3);
      }
      R = !1;
    }
    try {
      n = new IntersectionObserver(S, _objectSpread(_objectSpread({}, y), {}, {
        // Handle <iframe>s
        root: r.ownerDocument
      }));
    } catch (_unused2) {
      n = new IntersectionObserver(S, y);
    }
    n.observe(e);
  }
  return i(!0), s;
}
function No(e, t, n, o) {
  o === void 0 && (o = {});
  var _o2 = o,
    _o2$ancestorScroll = _o2.ancestorScroll,
    r = _o2$ancestorScroll === void 0 ? !0 : _o2$ancestorScroll,
    _o2$ancestorResize = _o2.ancestorResize,
    s = _o2$ancestorResize === void 0 ? !0 : _o2$ancestorResize,
    _o2$elementResize = _o2.elementResize,
    i = _o2$elementResize === void 0 ? typeof ResizeObserver == "function" : _o2$elementResize,
    _o2$layoutShift = _o2.layoutShift,
    c = _o2$layoutShift === void 0 ? typeof IntersectionObserver == "function" : _o2$layoutShift,
    _o2$animationFrame = _o2.animationFrame,
    l = _o2$animationFrame === void 0 ? !1 : _o2$animationFrame,
    u = bt(e),
    d = r || s ? [].concat(_toConsumableArray(u ? ae(u) : []), _toConsumableArray(ae(t))) : [];
  d.forEach(function (w) {
    r && w.addEventListener("scroll", n, {
      passive: !0
    }), s && w.addEventListener("resize", n);
  });
  var f = u && c ? Fo(u, n) : null;
  var p = -1,
    a = null;
  i && (a = new ResizeObserver(function (w) {
    var _w2 = _slicedToArray(w, 1),
      y = _w2[0];
    y && y.target === u && a && (a.unobserve(t), cancelAnimationFrame(p), p = requestAnimationFrame(function () {
      var R;
      (R = a) == null || R.observe(t);
    })), n();
  }), u && !l && a.observe(u), a.observe(t));
  var h,
    g = l ? he(e) : null;
  l && v();
  function v() {
    var w = he(e);
    g && (w.x !== g.x || w.y !== g.y || w.width !== g.width || w.height !== g.height) && n(), g = w, h = requestAnimationFrame(v);
  }
  return n(), function () {
    var w;
    d.forEach(function (y) {
      r && y.removeEventListener("scroll", n), s && y.removeEventListener("resize", n);
    }), f == null || f(), (w = a) == null || w.disconnect(), a = null, l && cancelAnimationFrame(h);
  };
}
var $o = ho,
  Bo = bo,
  _o = po,
  St = mo,
  zo = function zo(e, t, n) {
    var o = /* @__PURE__ */new Map(),
      r = _objectSpread({
        platform: Do
      }, n),
      s = _objectSpread(_objectSpread({}, r.platform), {}, {
        _c: o
      });
    return fo(e, t, _objectSpread(_objectSpread({}, r), {}, {
      platform: s
    }));
  };
var De = typeof document < "u" ? Wt : me;
function Ve(e, t) {
  if (e === t) return !0;
  if (typeof e != typeof t) return !1;
  if (typeof e == "function" && e.toString() === t.toString()) return !0;
  var n, o, r;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (o = n; o-- !== 0;) {
        if (!Ve(e[o], t[o])) return !1;
      }
      return !0;
    }
    if (r = Object.keys(e), n = r.length, n !== Object.keys(t).length) return !1;
    for (o = n; o-- !== 0;) {
      if (!{}.hasOwnProperty.call(t, r[o])) return !1;
    }
    for (o = n; o-- !== 0;) {
      var s = r[o];
      if (!(s === "_owner" && e.$$typeof) && !Ve(e[s], t[s])) return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function un(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Pt(e, t) {
  var n = un(e);
  return Math.round(t * n) / n;
}
function Ge(e) {
  var t = m.useRef(e);
  return De(function () {
    t.current = e;
  }), t;
}
function Wo(e) {
  e === void 0 && (e = {});
  var _e2 = e,
    _e2$placement = _e2.placement,
    t = _e2$placement === void 0 ? "bottom" : _e2$placement,
    _e2$strategy = _e2.strategy,
    n = _e2$strategy === void 0 ? "absolute" : _e2$strategy,
    _e2$middleware = _e2.middleware,
    o = _e2$middleware === void 0 ? [] : _e2$middleware,
    r = _e2.platform,
    _e2$elements = _e2.elements;
  _e2$elements = _e2$elements === void 0 ? {} : _e2$elements;
  var s = _e2$elements.reference,
    i = _e2$elements.floating,
    _e2$transform = _e2.transform,
    c = _e2$transform === void 0 ? !0 : _e2$transform,
    l = _e2.whileElementsMounted,
    u = _e2.open,
    _m$useState = m.useState({
      x: 0,
      y: 0,
      strategy: n,
      placement: t,
      middlewareData: {},
      isPositioned: !1
    }),
    _m$useState2 = _slicedToArray(_m$useState, 2),
    d = _m$useState2[0],
    f = _m$useState2[1],
    _m$useState3 = m.useState(o),
    _m$useState4 = _slicedToArray(_m$useState3, 2),
    p = _m$useState4[0],
    a = _m$useState4[1];
  Ve(p, o) || a(o);
  var _m$useState5 = m.useState(null),
    _m$useState6 = _slicedToArray(_m$useState5, 2),
    h = _m$useState6[0],
    g = _m$useState6[1],
    _m$useState7 = m.useState(null),
    _m$useState8 = _slicedToArray(_m$useState7, 2),
    v = _m$useState8[0],
    w = _m$useState8[1],
    y = m.useCallback(function (T) {
      T !== P.current && (P.current = T, g(T));
    }, []),
    R = m.useCallback(function (T) {
      T !== M.current && (M.current = T, w(T));
    }, []),
    S = s || h,
    A = i || v,
    P = m.useRef(null),
    M = m.useRef(null),
    D = m.useRef(d),
    B = l != null,
    _ = Ge(l),
    V = Ge(r),
    F = Ge(u),
    O = m.useCallback(function () {
      if (!P.current || !M.current) return;
      var T = {
        placement: t,
        strategy: n,
        middleware: p
      };
      V.current && (T.platform = V.current), zo(P.current, M.current, T).then(function (x) {
        var L = _objectSpread(_objectSpread({}, x), {}, {
          // The floating element's position may be recomputed while it's closed
          // but still mounted (such as when transitioning out). To ensure
          // `isPositioned` will be `false` initially on the next open, avoid
          // setting it to `true` when `open === false` (must be specified).
          isPositioned: F.current !== !1
        });
        b.current && !Ve(D.current, L) && (D.current = L, Vt.flushSync(function () {
          f(L);
        }));
      });
    }, [p, t, n, V, F]);
  De(function () {
    u === !1 && D.current.isPositioned && (D.current.isPositioned = !1, f(function (T) {
      return _objectSpread(_objectSpread({}, T), {}, {
        isPositioned: !1
      });
    }));
  }, [u]);
  var b = m.useRef(!1);
  De(function () {
    return b.current = !0, function () {
      b.current = !1;
    };
  }, []), De(function () {
    if (S && (P.current = S), A && (M.current = A), S && A) {
      if (_.current) return _.current(S, A, O);
      O();
    }
  }, [S, A, O, _, B]);
  var E = m.useMemo(function () {
      return {
        reference: P,
        floating: M,
        setReference: y,
        setFloating: R
      };
    }, [y, R]),
    k = m.useMemo(function () {
      return {
        reference: S,
        floating: A
      };
    }, [S, A]),
    C = m.useMemo(function () {
      var T = {
        position: n,
        left: 0,
        top: 0
      };
      if (!k.floating) return T;
      var x = Pt(k.floating, d.x),
        L = Pt(k.floating, d.y);
      return c ? _objectSpread(_objectSpread({}, T), {}, {
        transform: "translate(" + x + "px, " + L + "px)"
      }, un(k.floating) >= 1.5 && {
        willChange: "transform"
      }) : {
        position: n,
        left: x,
        top: L
      };
    }, [n, c, k.floating, d.x, d.y]);
  return m.useMemo(function () {
    return _objectSpread(_objectSpread({}, d), {}, {
      update: O,
      refs: E,
      elements: k,
      floatingStyles: C
    });
  }, [d, O, E, k, C]);
}
var Vo = function Vo(e) {
    function t(n) {
      return {}.hasOwnProperty.call(n, "current");
    }
    return {
      name: "arrow",
      options: e,
      fn(n) {
        var _ref4 = typeof e == "function" ? e(n) : e,
          o = _ref4.element,
          r = _ref4.padding;
        return o && t(o) ? o.current != null ? St({
          element: o.current,
          padding: r
        }).fn(n) : {} : o ? St({
          element: o,
          padding: r
        }).fn(n) : {};
      }
    };
  },
  Ho = function Ho(e, t) {
    return _objectSpread(_objectSpread({}, $o(e)), {}, {
      options: [e, t]
    });
  },
  Yo = function Yo(e, t) {
    return _objectSpread(_objectSpread({}, Bo(e)), {}, {
      options: [e, t]
    });
  },
  Xo = function Xo(e, t) {
    return _objectSpread(_objectSpread({}, _o(e)), {}, {
      options: [e, t]
    });
  },
  jo = function jo(e, t) {
    return _objectSpread(_objectSpread({}, Vo(e)), {}, {
      options: [e, t]
    });
  },
  an = _objectSpread({}, m),
  Uo = an.useInsertionEffect,
  Ko = Uo || function (e) {
    return e();
  };
function te(e) {
  var t = m.useRef(function () {
    if (process.env.NODE_ENV !== "production") throw new Error("Cannot call an event handler while rendering.");
  });
  return Ko(function () {
    t.current = e;
  }), m.useCallback(function () {
    for (var n = arguments.length, o = new Array(n), r = 0; r < n; r++) {
      o[r] = arguments[r];
    }
    return t.current == null ? void 0 : t.current.apply(t, o);
  }, []);
}
var q = typeof document < "u" ? Wt : me;
var At = !1,
  qo = 0;
var Lt = function Lt() {
  return (
    // Ensure the id is unique with multiple independent versions of Floating UI
    // on <React 18
    "floating-ui-" + Math.random().toString(36).slice(2, 6) + qo++
  );
};
function Go() {
  var _m$useState9 = m.useState(function () {
      return At ? Lt() : void 0;
    }),
    _m$useState10 = _slicedToArray(_m$useState9, 2),
    e = _m$useState10[0],
    t = _m$useState10[1];
  return q(function () {
    e == null && t(Lt());
  }, []), m.useEffect(function () {
    At = !0;
  }, []), e;
}
var Zo = an.useId,
  Le = Zo || Go;
var Te;
process.env.NODE_ENV !== "production" && (Te = /* @__PURE__ */new Set());
function Jo() {
  for (var e, t = arguments.length, n = new Array(t), o = 0; o < t; o++) {
    n[o] = arguments[o];
  }
  var r = "Floating UI: " + n.join(" ");
  if (!((e = Te) != null && e.has(r))) {
    var s;
    (s = Te) == null || s.add(r), console.warn(r);
  }
}
function Qo() {
  for (var e, t = arguments.length, n = new Array(t), o = 0; o < t; o++) {
    n[o] = arguments[o];
  }
  var r = "Floating UI: " + n.join(" ");
  if (!((e = Te) != null && e.has(r))) {
    var s;
    (s = Te) == null || s.add(r), console.error(r);
  }
}
var er = /* @__PURE__ */m.forwardRef(function (t, n) {
  var _t$context = t.context,
    o = _t$context.placement,
    r = _t$context.elements.floating,
    _t$context$middleware = _t$context.middlewareData,
    s = _t$context$middleware.arrow,
    i = _t$context$middleware.shift,
    _t$width = t.width,
    c = _t$width === void 0 ? 14 : _t$width,
    _t$height = t.height,
    l = _t$height === void 0 ? 7 : _t$height,
    _t$tipRadius = t.tipRadius,
    u = _t$tipRadius === void 0 ? 0 : _t$tipRadius,
    _t$strokeWidth = t.strokeWidth,
    d = _t$strokeWidth === void 0 ? 0 : _t$strokeWidth,
    f = t.staticOffset,
    p = t.stroke,
    a = t.d,
    _t$style = t.style;
  _t$style = _t$style === void 0 ? {} : _t$style;
  var h = _t$style.transform,
    g = _objectWithoutProperties(_t$style, _excluded3),
    v = _objectWithoutProperties(t, _excluded4);
  process.env.NODE_ENV !== "production" && (n || Jo("The `ref` prop is required for `FloatingArrow`."));
  var w = Le(),
    _m$useState11 = m.useState(!1),
    _m$useState12 = _slicedToArray(_m$useState11, 2),
    y = _m$useState12[0],
    R = _m$useState12[1];
  if (q(function () {
    if (!r) return;
    Xt(r).direction === "rtl" && R(!0);
  }, [r]), !r) return null;
  var _o$split = o.split("-"),
    _o$split2 = _slicedToArray(_o$split, 2),
    S = _o$split2[0],
    A = _o$split2[1],
    P = S === "top" || S === "bottom";
  var M = f;
  (P && i != null && i.x || !P && i != null && i.y) && (M = null);
  var D = d * 2,
    B = D / 2,
    _ = c / 2 * (u / -8 + 1),
    V = l / 2 * u / 4,
    F = !!a,
    O = M && A === "end" ? "bottom" : "top";
  var b = M && A === "end" ? "right" : "left";
  M && y && (b = A === "end" ? "left" : "right");
  var E = (s == null ? void 0 : s.x) != null ? M || s.x : "",
    k = (s == null ? void 0 : s.y) != null ? M || s.y : "",
    C = a || "M0,0" + (" H" + c) + (" L" + (c - _) + "," + (l - V)) + (" Q" + c / 2 + "," + l + " " + _ + "," + (l - V)) + " Z",
    T = {
      top: F ? "rotate(180deg)" : "",
      left: F ? "rotate(90deg)" : "rotate(-90deg)",
      bottom: F ? "" : "rotate(180deg)",
      right: F ? "rotate(-90deg)" : "rotate(90deg)"
    }[S];
  return /* @__PURE__ */Ee("svg", _objectSpread(_objectSpread({}, v), {}, {
    "aria-hidden": !0,
    ref: n,
    width: F ? c : c + D,
    height: c,
    viewBox: "0 0 " + c + " " + (l > c ? l : c),
    style: _objectSpread({
      position: "absolute",
      pointerEvents: "none",
      [b]: E,
      [O]: k,
      [S]: P || F ? "100%" : "calc(100% - " + D / 2 + "px)",
      transform: [T, h].filter(function (x) {
        return !!x;
      }).join(" ")
    }, g),
    children: [D > 0 && /* @__PURE__ */X("path", {
      clipPath: "url(#" + w + ")",
      fill: "none",
      stroke: p,
      strokeWidth: D + (a ? 0 : 1),
      d: C
    }), /* @__PURE__ */X("path", {
      stroke: D && !a ? v.fill : "none",
      d: C
    }), /* @__PURE__ */X("clipPath", {
      id: w,
      children: /* @__PURE__ */X("rect", {
        x: -B,
        y: B * (F ? -1 : 1),
        width: c + D,
        height: c
      })
    })]
  }));
});
function tr() {
  var e = /* @__PURE__ */new Map();
  return {
    emit(t, n) {
      var o;
      (o = e.get(t)) == null || o.forEach(function (r) {
        return r(n);
      });
    },
    on(t, n) {
      e.has(t) || e.set(t, /* @__PURE__ */new Set()), e.get(t).add(n);
    },
    off(t, n) {
      var o;
      (o = e.get(t)) == null || o.delete(n);
    }
  };
}
var fn = /* @__PURE__ */m.createContext(null),
  nr = /* @__PURE__ */m.createContext(null),
  ke = function ke() {
    var e;
    return ((e = m.useContext(fn)) == null ? void 0 : e.id) || null;
  },
  je = function je() {
    return m.useContext(nr);
  };
function or(e) {
  var t = Le(),
    n = je(),
    r = ke();
  return q(function () {
    if (!t) return;
    var s = {
      id: t,
      parentId: r
    };
    return n == null || n.addNode(s), function () {
      n == null || n.removeNode(s);
    };
  }, [n, t, r]), t;
}
function rr(e) {
  var t = e.children,
    n = e.id,
    o = ke();
  return /* @__PURE__ */X(fn.Provider, {
    value: m.useMemo(function () {
      return {
        id: n,
        parentId: o
      };
    }, [n, o]),
    children: t
  });
}
function Me(e) {
  return "data-floating-ui-" + e;
}
function J(e) {
  e.current !== -1 && (clearTimeout(e.current), e.current = -1);
}
function Ie(e) {
  var t = ot(e);
  return q(function () {
    t.current = e;
  }), t;
}
var kt = /* @__PURE__ */Me("safe-polygon");
function Ze(e, t, n) {
  if (n && !Ne(n)) return 0;
  if (typeof e == "number") return e;
  if (typeof e == "function") {
    var o = e();
    return typeof o == "number" ? o : o == null ? void 0 : o[t];
  }
  return e == null ? void 0 : e[t];
}
function Je(e) {
  return typeof e == "function" ? e() : e;
}
function ir(e, t) {
  t === void 0 && (t = {});
  var n = e.open,
    o = e.onOpenChange,
    r = e.dataRef,
    s = e.events,
    i = e.elements,
    _t2 = t,
    _t2$enabled = _t2.enabled,
    c = _t2$enabled === void 0 ? !0 : _t2$enabled,
    _t2$delay = _t2.delay,
    l = _t2$delay === void 0 ? 0 : _t2$delay,
    _t2$handleClose = _t2.handleClose,
    u = _t2$handleClose === void 0 ? null : _t2$handleClose,
    _t2$mouseOnly = _t2.mouseOnly,
    d = _t2$mouseOnly === void 0 ? !1 : _t2$mouseOnly,
    _t2$restMs = _t2.restMs,
    f = _t2$restMs === void 0 ? 0 : _t2$restMs,
    _t2$move = _t2.move,
    p = _t2$move === void 0 ? !0 : _t2$move,
    a = je(),
    h = ke(),
    g = Ie(u),
    v = Ie(l),
    w = Ie(n),
    y = Ie(f),
    R = m.useRef(),
    S = m.useRef(-1),
    A = m.useRef(),
    P = m.useRef(-1),
    M = m.useRef(!0),
    D = m.useRef(!1),
    B = m.useRef(function () {}),
    _ = m.useRef(!1),
    V = m.useCallback(function () {
      var C;
      var T = (C = r.current.openEvent) == null ? void 0 : C.type;
      return (T == null ? void 0 : T.includes("mouse")) && T !== "mousedown";
    }, [r]);
  m.useEffect(function () {
    if (!c) return;
    function C(T) {
      var x = T.open;
      x || (J(S), J(P), M.current = !0, _.current = !1);
    }
    return s.on("openchange", C), function () {
      s.off("openchange", C);
    };
  }, [c, s]), m.useEffect(function () {
    if (!c || !g.current || !n) return;
    function C(x) {
      V() && o(!1, x, "hover");
    }
    var T = oe(i.floating).documentElement;
    return T.addEventListener("mouseleave", C), function () {
      T.removeEventListener("mouseleave", C);
    };
  }, [i.floating, n, o, c, g, V]);
  var F = m.useCallback(function (C, T, x) {
      T === void 0 && (T = !0), x === void 0 && (x = "hover");
      var L = Ze(v.current, "close", R.current);
      L && !A.current ? (J(S), S.current = window.setTimeout(function () {
        return o(!1, C, x);
      }, L)) : T && (J(S), o(!1, C, x));
    }, [v, o]),
    O = te(function () {
      B.current(), A.current = void 0;
    }),
    b = te(function () {
      if (D.current) {
        var C = oe(i.floating).body;
        C.style.pointerEvents = "", C.removeAttribute(kt), D.current = !1;
      }
    }),
    E = te(function () {
      return r.current.openEvent ? ["click", "mousedown"].includes(r.current.openEvent.type) : !1;
    });
  m.useEffect(function () {
    if (!c) return;
    function C(I) {
      if (J(S), M.current = !1, d && !Ne(R.current) || Je(y.current) > 0 && !Ze(v.current, "open")) return;
      var z = Ze(v.current, "open", R.current);
      z ? S.current = window.setTimeout(function () {
        w.current || o(!0, I, "hover");
      }, z) : n || o(!0, I, "hover");
    }
    function T(I) {
      if (E()) {
        b();
        return;
      }
      B.current();
      var z = oe(i.floating);
      if (J(P), _.current = !1, g.current && r.current.floatingContext) {
        n || J(S), A.current = g.current(_objectSpread(_objectSpread({}, r.current.floatingContext), {}, {
          tree: a,
          x: I.clientX,
          y: I.clientY,
          onClose() {
            b(), O(), E() || F(I, !0, "safe-polygon");
          }
        }));
        var U = A.current;
        z.addEventListener("mousemove", U), B.current = function () {
          z.removeEventListener("mousemove", U);
        };
        return;
      }
      (R.current === "touch" ? !re(i.floating, I.relatedTarget) : !0) && F(I);
    }
    function x(I) {
      E() || r.current.floatingContext && (g.current == null || g.current(_objectSpread(_objectSpread({}, r.current.floatingContext), {}, {
        tree: a,
        x: I.clientX,
        y: I.clientY,
        onClose() {
          b(), O(), E() || F(I);
        }
      }))(I));
    }
    function L() {
      J(S);
    }
    function N(I) {
      E() || F(I, !1);
    }
    if (j(i.domReference)) {
      var I = i.domReference,
        z = i.floating;
      return n && I.addEventListener("mouseleave", x), p && I.addEventListener("mousemove", C, {
        once: !0
      }), I.addEventListener("mouseenter", C), I.addEventListener("mouseleave", T), z && (z.addEventListener("mouseleave", x), z.addEventListener("mouseenter", L), z.addEventListener("mouseleave", N)), function () {
        n && I.removeEventListener("mouseleave", x), p && I.removeEventListener("mousemove", C), I.removeEventListener("mouseenter", C), I.removeEventListener("mouseleave", T), z && (z.removeEventListener("mouseleave", x), z.removeEventListener("mouseenter", L), z.removeEventListener("mouseleave", N));
      };
    }
  }, [i, c, e, d, p, F, O, b, o, n, w, a, v, g, r, E, y]), q(function () {
    var C;
    if (c && n && (C = g.current) != null && C.__options.blockPointerEvents && V()) {
      D.current = !0;
      var x = i.floating;
      if (j(i.domReference) && x) {
        var T;
        var L = oe(i.floating).body;
        L.setAttribute(kt, "");
        var N = i.domReference,
          I = a == null || (T = a.nodesRef.current.find(function (z) {
            return z.id === h;
          })) == null || (T = T.context) == null ? void 0 : T.elements.floating;
        return I && (I.style.pointerEvents = ""), L.style.pointerEvents = "none", N.style.pointerEvents = "auto", x.style.pointerEvents = "auto", function () {
          L.style.pointerEvents = "", N.style.pointerEvents = "", x.style.pointerEvents = "";
        };
      }
    }
  }, [c, n, h, i, a, g, V]), q(function () {
    n || (R.current = void 0, _.current = !1, O(), b());
  }, [n, O, b]), m.useEffect(function () {
    return function () {
      O(), J(S), J(P), b();
    };
  }, [c, i.domReference, O, b]);
  var k = m.useMemo(function () {
    function C(T) {
      R.current = T.pointerType;
    }
    return {
      onPointerDown: C,
      onPointerEnter: C,
      onMouseMove(T) {
        var x = T.nativeEvent;
        function L() {
          !M.current && !w.current && o(!0, x, "hover");
        }
        d && !Ne(R.current) || n || Je(y.current) === 0 || _.current && Math.pow(T.movementX, 2) + Math.pow(T.movementY, 2) < 2 || (J(P), R.current === "touch" ? L() : (_.current = !0, P.current = window.setTimeout(L, Je(y.current))));
      }
    };
  }, [d, o, n, w, y]);
  return m.useMemo(function () {
    return c ? {
      reference: k
    } : {};
  }, [c, k]);
}
function Fe(e, t) {
  var n = e.filter(function (r) {
      var s;
      return r.parentId === t && ((s = r.context) == null ? void 0 : s.open);
    }),
    o = n;
  for (; o.length;) {
    o = e.filter(function (r) {
      var s;
      return (s = o) == null ? void 0 : s.some(function (i) {
        var c;
        return r.parentId === i.id && ((c = r.context) == null ? void 0 : c.open);
      });
    }), n = n.concat(o);
  }
  return n;
}
var dn = function dn() {
  return {
    getShadowRoot: !0,
    displayCheck:
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
  };
};
function mn(e, t) {
  var n = Zt(e, dn());
  t === "prev" && n.reverse();
  var o = n.indexOf(st(oe(e)));
  return n.slice(o + 1)[0];
}
function sr(e) {
  return mn(oe(e).body, "next") || e;
}
function cr(e) {
  return mn(oe(e).body, "prev") || e;
}
function Qe(e, t) {
  var n = t || e.currentTarget,
    o = e.relatedTarget;
  return !o || !re(n, o);
}
function lr(e) {
  Zt(e, dn()).forEach(function (n) {
    n.dataset.tabindex = n.getAttribute("tabindex") || "", n.setAttribute("tabindex", "-1");
  });
}
function Mt(e) {
  e.querySelectorAll("[data-tabindex]").forEach(function (n) {
    var o = n.dataset.tabindex;
    delete n.dataset.tabindex, o ? n.setAttribute("tabindex", o) : n.removeAttribute("tabindex");
  });
}
var pn = {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "fixed",
    whiteSpace: "nowrap",
    width: "1px",
    top: 0,
    left: 0
  },
  Ot = /* @__PURE__ */m.forwardRef(function (t, n) {
    var _m$useState13 = m.useState(),
      _m$useState14 = _slicedToArray(_m$useState13, 2),
      o = _m$useState14[0],
      r = _m$useState14[1];
    q(function () {
      jt() && r("button");
    }, []);
    var s = {
      ref: n,
      tabIndex: 0,
      // Role is only for VoiceOver
      role: o,
      "aria-hidden": o ? void 0 : !0,
      [Me("focus-guard")]: "",
      style: pn
    };
    return /* @__PURE__ */X("span", _objectSpread(_objectSpread({}, t), s));
  }),
  gn = /* @__PURE__ */m.createContext(null),
  It = /* @__PURE__ */Me("portal");
function ur(e) {
  e === void 0 && (e = {});
  var _e3 = e,
    t = _e3.id,
    n = _e3.root,
    o = Le(),
    r = fr(),
    _m$useState15 = m.useState(null),
    _m$useState16 = _slicedToArray(_m$useState15, 2),
    s = _m$useState16[0],
    i = _m$useState16[1],
    c = m.useRef(null);
  return q(function () {
    return function () {
      s == null || s.remove(), queueMicrotask(function () {
        c.current = null;
      });
    };
  }, [s]), q(function () {
    if (!o || c.current) return;
    var l = t ? document.getElementById(t) : null;
    if (!l) return;
    var u = document.createElement("div");
    u.id = o, u.setAttribute(It, ""), l.appendChild(u), c.current = u, i(u);
  }, [t, o]), q(function () {
    if (n === null || !o || c.current) return;
    var l = n || (r == null ? void 0 : r.portalNode);
    l && !j(l) && (l = l.current), l = l || document.body;
    var u = null;
    t && (u = document.createElement("div"), u.id = t, l.appendChild(u));
    var d = document.createElement("div");
    d.id = o, d.setAttribute(It, ""), l = u || l, l.appendChild(d), c.current = d, i(d);
  }, [t, n, o, r]), s;
}
function ar(e) {
  var t = e.children,
    n = e.id,
    o = e.root,
    _e$preserveTabOrder = e.preserveTabOrder,
    r = _e$preserveTabOrder === void 0 ? !0 : _e$preserveTabOrder,
    s = ur({
      id: n,
      root: o
    }),
    _m$useState17 = m.useState(null),
    _m$useState18 = _slicedToArray(_m$useState17, 2),
    i = _m$useState18[0],
    c = _m$useState18[1],
    l = m.useRef(null),
    u = m.useRef(null),
    d = m.useRef(null),
    f = m.useRef(null),
    p = i == null ? void 0 : i.modal,
    a = i == null ? void 0 : i.open,
    h =
    // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!i &&
    // Guards are only for non-modal focus management.
    !i.modal &&
    // Don't render if unmount is transitioning.
    i.open && r && !!(o || s);
  return m.useEffect(function () {
    if (!s || !r || p) return;
    function g(v) {
      s && Qe(v) && (v.type === "focusin" ? Mt : lr)(s);
    }
    return s.addEventListener("focusin", g, !0), s.addEventListener("focusout", g, !0), function () {
      s.removeEventListener("focusin", g, !0), s.removeEventListener("focusout", g, !0);
    };
  }, [s, r, p]), m.useEffect(function () {
    s && (a || Mt(s));
  }, [a, s]), /* @__PURE__ */Ee(gn.Provider, {
    value: m.useMemo(function () {
      return {
        preserveTabOrder: r,
        beforeOutsideRef: l,
        afterOutsideRef: u,
        beforeInsideRef: d,
        afterInsideRef: f,
        portalNode: s,
        setFocusManagerState: c
      };
    }, [r, s]),
    children: [h && s && /* @__PURE__ */X(Ot, {
      "data-type": "outside",
      ref: l,
      onFocus: function onFocus(g) {
        if (Qe(g, s)) {
          var v;
          (v = d.current) == null || v.focus();
        } else {
          var w = i ? i.domReference : null,
            y = cr(w);
          y == null || y.focus();
        }
      }
    }), h && s && /* @__PURE__ */X("span", {
      "aria-owns": s.id,
      style: pn
    }), s && /* @__PURE__ */Vt.createPortal(t, s), h && s && /* @__PURE__ */X(Ot, {
      "data-type": "outside",
      ref: u,
      onFocus: function onFocus(g) {
        if (Qe(g, s)) {
          var v;
          (v = f.current) == null || v.focus();
        } else {
          var w = i ? i.domReference : null,
            y = sr(w);
          y == null || y.focus(), i != null && i.closeOnFocusOut && (i == null || i.onOpenChange(!1, g.nativeEvent, "focus-out"));
        }
      }
    })]
  });
}
var fr = function fr() {
    return m.useContext(gn);
  },
  at = "data-floating-ui-focusable";
function dr(e) {
  return e ? e.hasAttribute(at) ? e : e.querySelector("[" + at + "]") || e : null;
}
function mr(e, t) {
  var n = null,
    o = null,
    r = !1;
  return {
    contextElement: e || void 0,
    getBoundingClientRect() {
      var s;
      var i = (e == null ? void 0 : e.getBoundingClientRect()) || {
          width: 0,
          height: 0,
          x: 0,
          y: 0
        },
        c = t.axis === "x" || t.axis === "both",
        l = t.axis === "y" || t.axis === "both",
        u = ["mouseenter", "mousemove"].includes(((s = t.dataRef.current.openEvent) == null ? void 0 : s.type) || "") && t.pointerType !== "touch";
      var d = i.width,
        f = i.height,
        p = i.x,
        a = i.y;
      return n == null && t.x && c && (n = i.x - t.x), o == null && t.y && l && (o = i.y - t.y), p -= n || 0, a -= o || 0, d = 0, f = 0, !r || u ? (d = t.axis === "y" ? i.width : 0, f = t.axis === "x" ? i.height : 0, p = c && t.x != null ? t.x : p, a = l && t.y != null ? t.y : a) : r && !u && (f = t.axis === "x" ? i.height : f, d = t.axis === "y" ? i.width : d), r = !0, {
        width: d,
        height: f,
        x: p,
        y: a,
        top: a,
        right: p + d,
        bottom: a + f,
        left: p
      };
    }
  };
}
function Dt(e) {
  return e != null && e.clientX != null;
}
function pr(e, t) {
  t === void 0 && (t = {});
  var n = e.open,
    o = e.dataRef,
    _e$elements = e.elements,
    r = _e$elements.floating,
    s = _e$elements.domReference,
    i = e.refs,
    _t3 = t,
    _t3$enabled = _t3.enabled,
    c = _t3$enabled === void 0 ? !0 : _t3$enabled,
    _t3$axis = _t3.axis,
    l = _t3$axis === void 0 ? "both" : _t3$axis,
    _t3$x = _t3.x,
    u = _t3$x === void 0 ? null : _t3$x,
    _t3$y = _t3.y,
    d = _t3$y === void 0 ? null : _t3$y,
    f = m.useRef(!1),
    p = m.useRef(null),
    _m$useState19 = m.useState(),
    _m$useState20 = _slicedToArray(_m$useState19, 2),
    a = _m$useState20[0],
    h = _m$useState20[1],
    _m$useState21 = m.useState([]),
    _m$useState22 = _slicedToArray(_m$useState21, 2),
    g = _m$useState22[0],
    v = _m$useState22[1],
    w = te(function (P, M) {
      f.current || o.current.openEvent && !Dt(o.current.openEvent) || i.setPositionReference(mr(s, {
        x: P,
        y: M,
        axis: l,
        dataRef: o,
        pointerType: a
      }));
    }),
    y = te(function (P) {
      u != null || d != null || (n ? p.current || v([]) : w(P.clientX, P.clientY));
    }),
    R = Ne(a) ? r : n,
    S = m.useCallback(function () {
      if (!R || !c || u != null || d != null) return;
      var P = ve(r);
      function M(D) {
        var B = ue(D);
        re(r, B) ? (P.removeEventListener("mousemove", M), p.current = null) : w(D.clientX, D.clientY);
      }
      if (!o.current.openEvent || Dt(o.current.openEvent)) {
        P.addEventListener("mousemove", M);
        var D = function D() {
          P.removeEventListener("mousemove", M), p.current = null;
        };
        return p.current = D, D;
      }
      i.setPositionReference(s);
    }, [R, c, u, d, r, o, i, s, w]);
  m.useEffect(function () {
    return S();
  }, [S, g]), m.useEffect(function () {
    c && !r && (f.current = !1);
  }, [c, r]), m.useEffect(function () {
    !c && n && (f.current = !0);
  }, [c, n]), q(function () {
    c && (u != null || d != null) && (f.current = !1, w(u, d));
  }, [c, u, d, w]);
  var A = m.useMemo(function () {
    function P(M) {
      var D = M.pointerType;
      h(D);
    }
    return {
      onPointerDown: P,
      onPointerEnter: P,
      onMouseMove: y,
      onMouseEnter: y
    };
  }, [y]);
  return m.useMemo(function () {
    return c ? {
      reference: A
    } : {};
  }, [c, A]);
}
var gr = {
    pointerdown: "onPointerDown",
    mousedown: "onMouseDown",
    click: "onClick"
  },
  hr = {
    pointerdown: "onPointerDownCapture",
    mousedown: "onMouseDownCapture",
    click: "onClickCapture"
  },
  Ft = function Ft(e) {
    var t, n;
    return {
      escapeKey: typeof e == "boolean" ? e : (t = e == null ? void 0 : e.escapeKey) != null ? t : !1,
      outsidePress: typeof e == "boolean" ? e : (n = e == null ? void 0 : e.outsidePress) != null ? n : !0
    };
  };
function br(e, t) {
  t === void 0 && (t = {});
  var n = e.open,
    o = e.onOpenChange,
    r = e.elements,
    s = e.dataRef,
    _t4 = t,
    _t4$enabled = _t4.enabled,
    i = _t4$enabled === void 0 ? !0 : _t4$enabled,
    _t4$escapeKey = _t4.escapeKey,
    c = _t4$escapeKey === void 0 ? !0 : _t4$escapeKey,
    _t4$outsidePress = _t4.outsidePress,
    l = _t4$outsidePress === void 0 ? !0 : _t4$outsidePress,
    _t4$outsidePressEvent = _t4.outsidePressEvent,
    u = _t4$outsidePressEvent === void 0 ? "pointerdown" : _t4$outsidePressEvent,
    _t4$referencePress = _t4.referencePress,
    d = _t4$referencePress === void 0 ? !1 : _t4$referencePress,
    _t4$referencePressEve = _t4.referencePressEvent,
    f = _t4$referencePressEve === void 0 ? "pointerdown" : _t4$referencePressEve,
    _t4$ancestorScroll = _t4.ancestorScroll,
    p = _t4$ancestorScroll === void 0 ? !1 : _t4$ancestorScroll,
    a = _t4.bubbles,
    h = _t4.capture,
    g = je(),
    v = te(typeof l == "function" ? l : function () {
      return !1;
    }),
    w = typeof l == "function" ? v : l,
    y = m.useRef(!1),
    R = m.useRef(!1),
    _Ft = Ft(a),
    S = _Ft.escapeKey,
    A = _Ft.outsidePress,
    _Ft2 = Ft(h),
    P = _Ft2.escapeKey,
    M = _Ft2.outsidePress,
    D = m.useRef(!1),
    B = te(function (E) {
      var k;
      if (!n || !i || !c || E.key !== "Escape" || D.current) return;
      var C = (k = s.current.floatingContext) == null ? void 0 : k.nodeId,
        T = g ? Fe(g.nodesRef.current, C) : [];
      if (!S && (E.stopPropagation(), T.length > 0)) {
        var x = !0;
        if (T.forEach(function (L) {
          var N;
          if ((N = L.context) != null && N.open && !L.context.dataRef.current.__escapeKeyBubbles) {
            x = !1;
            return;
          }
        }), !x) return;
      }
      o(!1, Nn(E) ? E.nativeEvent : E, "escape-key");
    }),
    _ = te(function (E) {
      var k;
      var C = function C() {
        var T;
        B(E), (T = ue(E)) == null || T.removeEventListener("keydown", C);
      };
      (k = ue(E)) == null || k.addEventListener("keydown", C);
    }),
    V = te(function (E) {
      var k;
      var C = y.current;
      y.current = !1;
      var T = R.current;
      if (R.current = !1, u === "click" && T || C || typeof w == "function" && !w(E)) return;
      var x = ue(E),
        L = "[" + Me("inert") + "]",
        N = oe(r.floating).querySelectorAll(L);
      var I = j(x) ? x : null;
      for (; I && !Ue(I);) {
        var Y = In(I);
        if (Ue(Y) || !j(Y)) break;
        I = Y;
      }
      if (N.length && j(x) && !$n(x) &&
      // Clicked on a direct ancestor (e.g. FloatingOverlay).
      !re(x, r.floating) &&
      // If the target root element contains none of the markers, then the
      // element was injected after the floating element rendered.
      Array.from(N).every(function (Y) {
        return !re(I, Y);
      })) return;
      if (dt(x) && b) {
        var _Y = Ue(x),
          H = Xt(x),
          W = /auto|scroll/,
          $ = _Y || W.test(H.overflowX),
          ee = _Y || W.test(H.overflowY),
          Z = $ && x.clientWidth > 0 && x.scrollWidth > x.clientWidth,
          le = ee && x.clientHeight > 0 && x.scrollHeight > x.clientHeight,
          Rn = H.direction === "rtl",
          En = le && (Rn ? E.offsetX <= x.offsetWidth - x.clientWidth : E.offsetX > x.clientWidth),
          Cn = Z && E.offsetY > x.clientHeight;
        if (En || Cn) return;
      }
      var z = (k = s.current.floatingContext) == null ? void 0 : k.nodeId,
        G = g && Fe(g.nodesRef.current, z).some(function (Y) {
          var H;
          return Ke(E, (H = Y.context) == null ? void 0 : H.elements.floating);
        });
      if (Ke(E, r.floating) || Ke(E, r.domReference) || G) return;
      var U = g ? Fe(g.nodesRef.current, z) : [];
      if (U.length > 0) {
        var _Y2 = !0;
        if (U.forEach(function (H) {
          var W;
          if ((W = H.context) != null && W.open && !H.context.dataRef.current.__outsidePressBubbles) {
            _Y2 = !1;
            return;
          }
        }), !_Y2) return;
      }
      o(!1, E, "outside-press");
    }),
    F = te(function (E) {
      var k;
      var C = function C() {
        var T;
        V(E), (T = ue(E)) == null || T.removeEventListener(u, C);
      };
      (k = ue(E)) == null || k.addEventListener(u, C);
    });
  m.useEffect(function () {
    if (!n || !i) return;
    s.current.__escapeKeyBubbles = S, s.current.__outsidePressBubbles = A;
    var E = -1;
    function k(N) {
      o(!1, N, "ancestor-scroll");
    }
    function C() {
      window.clearTimeout(E), D.current = !0;
    }
    function T() {
      E = window.setTimeout(function () {
        D.current = !1;
      },
      // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
      // Only apply to WebKit for the test to remain 0ms.
      On() ? 5 : 0);
    }
    var x = oe(r.floating);
    c && (x.addEventListener("keydown", P ? _ : B, P), x.addEventListener("compositionstart", C), x.addEventListener("compositionend", T)), w && x.addEventListener(u, M ? F : V, M);
    var L = [];
    return p && (j(r.domReference) && (L = ae(r.domReference)), j(r.floating) && (L = L.concat(ae(r.floating))), !j(r.reference) && r.reference && r.reference.contextElement && (L = L.concat(ae(r.reference.contextElement)))), L = L.filter(function (N) {
      var I;
      return N !== ((I = x.defaultView) == null ? void 0 : I.visualViewport);
    }), L.forEach(function (N) {
      N.addEventListener("scroll", k, {
        passive: !0
      });
    }), function () {
      c && (x.removeEventListener("keydown", P ? _ : B, P), x.removeEventListener("compositionstart", C), x.removeEventListener("compositionend", T)), w && x.removeEventListener(u, M ? F : V, M), L.forEach(function (N) {
        N.removeEventListener("scroll", k);
      }), window.clearTimeout(E);
    };
  }, [s, r, c, w, u, n, o, p, i, S, A, B, P, _, V, M, F]), m.useEffect(function () {
    y.current = !1;
  }, [w, u]);
  var O = m.useMemo(function () {
      return _objectSpread({
        onKeyDown: B
      }, d && _objectSpread({
        [gr[f]]: function (E) {
          o(!1, E.nativeEvent, "reference-press");
        }
      }, f !== "click" && {
        onClick(E) {
          o(!1, E.nativeEvent, "reference-press");
        }
      }));
    }, [B, o, d, f]),
    b = m.useMemo(function () {
      return {
        onKeyDown: B,
        onMouseDown() {
          R.current = !0;
        },
        onMouseUp() {
          R.current = !0;
        },
        [hr[u]]: function () {
          y.current = !0;
        }
      };
    }, [B, u]);
  return m.useMemo(function () {
    return i ? {
      reference: O,
      floating: b
    } : {};
  }, [i, O, b]);
}
function vr(e) {
  var _e$open = e.open,
    t = _e$open === void 0 ? !1 : _e$open,
    n = e.onOpenChange,
    o = e.elements,
    r = Le(),
    s = m.useRef({}),
    _m$useState23 = m.useState(function () {
      return tr();
    }),
    _m$useState24 = _slicedToArray(_m$useState23, 1),
    i = _m$useState24[0],
    c = ke() != null;
  if (process.env.NODE_ENV !== "production") {
    var a = o.reference;
    a && !j(a) && Qo("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  var _m$useState25 = m.useState(o.reference),
    _m$useState26 = _slicedToArray(_m$useState25, 2),
    l = _m$useState26[0],
    u = _m$useState26[1],
    d = te(function (a, h, g) {
      s.current.openEvent = a ? h : void 0, i.emit("openchange", {
        open: a,
        event: h,
        reason: g,
        nested: c
      }), n == null || n(a, h, g);
    }),
    f = m.useMemo(function () {
      return {
        setPositionReference: u
      };
    }, []),
    p = m.useMemo(function () {
      return {
        reference: l || o.reference || null,
        floating: o.floating || null,
        domReference: o.reference
      };
    }, [l, o.reference, o.floating]);
  return m.useMemo(function () {
    return {
      dataRef: s,
      open: t,
      onOpenChange: d,
      elements: p,
      events: i,
      floatingId: r,
      refs: f
    };
  }, [t, d, p, i, r, f]);
}
function wr(e) {
  e === void 0 && (e = {});
  var _e4 = e,
    t = _e4.nodeId,
    n = vr(_objectSpread(_objectSpread({}, e), {}, {
      elements: _objectSpread({
        reference: null,
        floating: null
      }, e.elements)
    })),
    o = e.rootContext || n,
    r = o.elements,
    _m$useState27 = m.useState(null),
    _m$useState28 = _slicedToArray(_m$useState27, 2),
    s = _m$useState28[0],
    i = _m$useState28[1],
    _m$useState29 = m.useState(null),
    _m$useState30 = _slicedToArray(_m$useState29, 2),
    c = _m$useState30[0],
    l = _m$useState30[1],
    d = (r == null ? void 0 : r.domReference) || s,
    f = m.useRef(null),
    p = je();
  q(function () {
    d && (f.current = d);
  }, [d]);
  var a = Wo(_objectSpread(_objectSpread({}, e), {}, {
      elements: _objectSpread(_objectSpread({}, r), c && {
        reference: c
      })
    })),
    h = m.useCallback(function (R) {
      var S = j(R) ? {
        getBoundingClientRect: function getBoundingClientRect() {
          return R.getBoundingClientRect();
        },
        getClientRects: function getClientRects() {
          return R.getClientRects();
        },
        contextElement: R
      } : R;
      l(S), a.refs.setReference(S);
    }, [a.refs]),
    g = m.useCallback(function (R) {
      (j(R) || R === null) && (f.current = R, i(R)), (j(a.refs.reference.current) || a.refs.reference.current === null ||
      // Don't allow setting virtual elements using the old technique back to
      // `null` to support `positionReference` + an unstable `reference`
      // callback ref.
      R !== null && !j(R)) && a.refs.setReference(R);
    }, [a.refs]),
    v = m.useMemo(function () {
      return _objectSpread(_objectSpread({}, a.refs), {}, {
        setReference: g,
        setPositionReference: h,
        domReference: f
      });
    }, [a.refs, g, h]),
    w = m.useMemo(function () {
      return _objectSpread(_objectSpread({}, a.elements), {}, {
        domReference: d
      });
    }, [a.elements, d]),
    y = m.useMemo(function () {
      return _objectSpread(_objectSpread(_objectSpread({}, a), o), {}, {
        refs: v,
        elements: w,
        nodeId: t
      });
    }, [a, v, w, t, o]);
  return q(function () {
    o.dataRef.current.floatingContext = y;
    var R = p == null ? void 0 : p.nodesRef.current.find(function (S) {
      return S.id === t;
    });
    R && (R.context = y);
  }), m.useMemo(function () {
    return _objectSpread(_objectSpread({}, a), {}, {
      context: y,
      refs: v,
      elements: w
    });
  }, [a, v, w, y]);
}
function yr() {
  var e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map(function (t) {
    var n = t.brand,
      o = t.version;
    return n + "/" + o;
  }).join(" ") : navigator.userAgent;
}
function xr() {
  return yr().includes("jsdom/");
}
function Rr(e) {
  if (!e || xr()) return !0;
  try {
    return e.matches(":focus-visible");
  } catch (_unused3) {
    return !0;
  }
}
function et() {
  return Fn() && jt();
}
function Er(e, t) {
  t === void 0 && (t = {});
  var n = e.open,
    o = e.onOpenChange,
    r = e.events,
    s = e.dataRef,
    i = e.elements,
    _t5 = t,
    _t5$enabled = _t5.enabled,
    c = _t5$enabled === void 0 ? !0 : _t5$enabled,
    _t5$visibleOnly = _t5.visibleOnly,
    l = _t5$visibleOnly === void 0 ? !0 : _t5$visibleOnly,
    u = m.useRef(!1),
    d = m.useRef(-1),
    f = m.useRef(!0);
  m.useEffect(function () {
    if (!c) return;
    var a = ve(i.domReference);
    function h() {
      !n && dt(i.domReference) && i.domReference === st(oe(i.domReference)) && (u.current = !0);
    }
    function g() {
      f.current = !0;
    }
    function v() {
      f.current = !1;
    }
    return a.addEventListener("blur", h), et() && (a.addEventListener("keydown", g, !0), a.addEventListener("pointerdown", v, !0)), function () {
      a.removeEventListener("blur", h), et() && (a.removeEventListener("keydown", g, !0), a.removeEventListener("pointerdown", v, !0));
    };
  }, [i.domReference, n, c]), m.useEffect(function () {
    if (!c) return;
    function a(h) {
      var g = h.reason;
      (g === "reference-press" || g === "escape-key") && (u.current = !0);
    }
    return r.on("openchange", a), function () {
      r.off("openchange", a);
    };
  }, [r, c]), m.useEffect(function () {
    return function () {
      J(d);
    };
  }, []);
  var p = m.useMemo(function () {
    return {
      onMouseLeave() {
        u.current = !1;
      },
      onFocus(a) {
        if (u.current) return;
        var h = ue(a.nativeEvent);
        if (l && j(h)) {
          if (et() && !a.relatedTarget) {
            if (!f.current && !_n(h)) return;
          } else if (!Rr(h)) return;
        }
        o(!0, a.nativeEvent, "focus");
      },
      onBlur(a) {
        u.current = !1;
        var h = a.relatedTarget,
          g = a.nativeEvent,
          v = j(h) && h.hasAttribute(Me("focus-guard")) && h.getAttribute("data-type") === "outside";
        d.current = window.setTimeout(function () {
          var w;
          var y = st(i.domReference ? i.domReference.ownerDocument : document);
          !h && y === i.domReference || re((w = s.current.floatingContext) == null ? void 0 : w.refs.floating.current, y) || re(i.domReference, y) || v || o(!1, g, "focus");
        });
      }
    };
  }, [s, i.domReference, o, l]);
  return m.useMemo(function () {
    return c ? {
      reference: p
    } : {};
  }, [c, p]);
}
var Nt = "active",
  $t = "selected";
function tt(e, t, n) {
  var o = /* @__PURE__ */new Map(),
    r = n === "item";
  var s = e;
  if (r && e) {
    var i = e[Nt],
      c = e[$t],
      l = _objectWithoutProperties(e, [Nt, $t].map(_toPropertyKey));
    s = l;
  }
  return _objectSpread(_objectSpread(_objectSpread({}, n === "floating" && {
    tabIndex: -1,
    [at]: ""
  }), s), t.map(function (i) {
    var c = i ? i[n] : null;
    return typeof c == "function" ? e ? c(e) : null : c;
  }).concat(e).reduce(function (i, c) {
    return c && Object.entries(c).forEach(function (l) {
      var _l = _slicedToArray(l, 2),
        u = _l[0],
        d = _l[1];
      if (!(r && [Nt, $t].includes(u))) if (u.indexOf("on") === 0) {
        if (o.has(u) || o.set(u, []), typeof d == "function") {
          var f;
          (f = o.get(u)) == null || f.push(d), i[u] = function () {
            for (var p, a = arguments.length, h = new Array(a), g = 0; g < a; g++) {
              h[g] = arguments[g];
            }
            return (p = o.get(u)) == null ? void 0 : p.map(function (v) {
              return v.apply(void 0, h);
            }).find(function (v) {
              return v !== void 0;
            });
          };
        }
      } else i[u] = d;
    }), i;
  }, {}));
}
function Cr(e) {
  e === void 0 && (e = []);
  var t = e.map(function (c) {
      return c == null ? void 0 : c.reference;
    }),
    n = e.map(function (c) {
      return c == null ? void 0 : c.floating;
    }),
    o = e.map(function (c) {
      return c == null ? void 0 : c.item;
    }),
    r = m.useCallback(function (c) {
      return tt(c, e, "reference");
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t),
    s = m.useCallback(function (c) {
      return tt(c, e, "floating");
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    n),
    i = m.useCallback(function (c) {
      return tt(c, e, "item");
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    o);
  return m.useMemo(function () {
    return {
      getReferenceProps: r,
      getFloatingProps: s,
      getItemProps: i
    };
  }, [r, s, i]);
}
var Tr = /* @__PURE__ */new Map([["select", "listbox"], ["combobox", "listbox"], ["label", !1]]);
function Sr(e, t) {
  var n, o;
  t === void 0 && (t = {});
  var r = e.open,
    s = e.elements,
    i = e.floatingId,
    _t6 = t,
    _t6$enabled = _t6.enabled,
    c = _t6$enabled === void 0 ? !0 : _t6$enabled,
    _t6$role = _t6.role,
    l = _t6$role === void 0 ? "dialog" : _t6$role,
    u = Le(),
    d = ((n = s.domReference) == null ? void 0 : n.id) || u,
    f = m.useMemo(function () {
      var y;
      return ((y = dr(s.floating)) == null ? void 0 : y.id) || i;
    }, [s.floating, i]),
    p = (o = Tr.get(l)) != null ? o : l,
    h = ke() != null,
    g = m.useMemo(function () {
      return p === "tooltip" || l === "label" ? {
        ["aria-" + (l === "label" ? "labelledby" : "describedby")]: r ? f : void 0
      } : _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
        "aria-expanded": r ? "true" : "false",
        "aria-haspopup": p === "alertdialog" ? "dialog" : p,
        "aria-controls": r ? f : void 0
      }, p === "listbox" && {
        role: "combobox"
      }), p === "menu" && {
        id: d
      }), p === "menu" && h && {
        role: "menuitem"
      }), l === "select" && {
        "aria-autocomplete": "none"
      }), l === "combobox" && {
        "aria-autocomplete": "list"
      });
    }, [p, f, h, r, d, l]),
    v = m.useMemo(function () {
      var y = _objectSpread({
        id: f
      }, p && {
        role: p
      });
      return p === "tooltip" || l === "label" ? y : _objectSpread(_objectSpread({}, y), p === "menu" && {
        "aria-labelledby": d
      });
    }, [p, f, d, l]),
    w = m.useCallback(function (y) {
      var R = y.active,
        S = y.selected;
      var A = _objectSpread({
        role: "option"
      }, R && {
        id: f + "-fui-option"
      });
      switch (l) {
        case "select":
          return _objectSpread(_objectSpread({}, A), {}, {
            "aria-selected": R && S
          });
        case "combobox":
          return _objectSpread(_objectSpread({}, A), {}, {
            "aria-selected": S
          });
      }
      return {};
    }, [f, l]);
  return m.useMemo(function () {
    return c ? {
      reference: g,
      floating: v,
      item: w
    } : {};
  }, [c, g, v, w]);
}
function Bt(e, t) {
  var _e5 = _slicedToArray(e, 2),
    n = _e5[0],
    o = _e5[1];
  var r = !1;
  var s = t.length;
  for (var i = 0, c = s - 1; i < s; c = i++) {
    var _ref5 = t[i] || [0, 0],
      _ref6 = _slicedToArray(_ref5, 2),
      l = _ref6[0],
      u = _ref6[1],
      _ref7 = t[c] || [0, 0],
      _ref8 = _slicedToArray(_ref7, 2),
      d = _ref8[0],
      f = _ref8[1];
    u >= o != f >= o && n <= (d - l) * (o - u) / (f - u) + l && (r = !r);
  }
  return r;
}
function Pr(e, t) {
  return e[0] >= t.x && e[0] <= t.x + t.width && e[1] >= t.y && e[1] <= t.y + t.height;
}
function hn(e) {
  e === void 0 && (e = {});
  var _e6 = e,
    _e6$buffer = _e6.buffer,
    t = _e6$buffer === void 0 ? 0.5 : _e6$buffer,
    _e6$blockPointerEvent = _e6.blockPointerEvents,
    n = _e6$blockPointerEvent === void 0 ? !1 : _e6$blockPointerEvent,
    _e6$requireIntent = _e6.requireIntent,
    o = _e6$requireIntent === void 0 ? !0 : _e6$requireIntent;
  var r,
    s = !1,
    i = null,
    c = null,
    l = performance.now();
  function u(f, p) {
    var a = performance.now(),
      h = a - l;
    if (i === null || c === null || h === 0) return i = f, c = p, l = a, null;
    var g = f - i,
      v = p - c,
      y = Math.sqrt(g * g + v * v) / h;
    return i = f, c = p, l = a, y;
  }
  var d = function d(f) {
    var p = f.x,
      a = f.y,
      h = f.placement,
      g = f.elements,
      v = f.onClose,
      w = f.nodeId,
      y = f.tree;
    return function (S) {
      function A() {
        clearTimeout(r), v();
      }
      if (clearTimeout(r), !g.domReference || !g.floating || h == null || p == null || a == null) return;
      var P = S.clientX,
        M = S.clientY,
        D = [P, M],
        B = ue(S),
        _ = S.type === "mouseleave",
        V = re(g.floating, B),
        F = re(g.domReference, B),
        O = g.domReference.getBoundingClientRect(),
        b = g.floating.getBoundingClientRect(),
        E = h.split("-")[0],
        k = p > b.right - b.width / 2,
        C = a > b.bottom - b.height / 2,
        T = Pr(D, O),
        x = b.width > O.width,
        L = b.height > O.height,
        N = (x ? O : b).left,
        I = (x ? O : b).right,
        z = (L ? O : b).top,
        G = (L ? O : b).bottom;
      if (V && (s = !0, !_)) return;
      if (F && (s = !1), F && !_) {
        s = !0;
        return;
      }
      if (_ && j(S.relatedTarget) && re(g.floating, S.relatedTarget) || y && Fe(y.nodesRef.current, w).some(function (H) {
        var W = H.context;
        return W == null ? void 0 : W.open;
      })) return;
      if (E === "top" && a >= O.bottom - 1 || E === "bottom" && a <= O.top + 1 || E === "left" && p >= O.right - 1 || E === "right" && p <= O.left + 1) return A();
      var U = [];
      switch (E) {
        case "top":
          U = [[N, O.top + 1], [N, b.bottom - 1], [I, b.bottom - 1], [I, O.top + 1]];
          break;
        case "bottom":
          U = [[N, b.top + 1], [N, O.bottom - 1], [I, O.bottom - 1], [I, b.top + 1]];
          break;
        case "left":
          U = [[b.right - 1, G], [b.right - 1, z], [O.left + 1, z], [O.left + 1, G]];
          break;
        case "right":
          U = [[O.right - 1, G], [O.right - 1, z], [b.left + 1, z], [b.left + 1, G]];
          break;
      }
      function Y(H) {
        var _H = _slicedToArray(H, 2),
          W = _H[0],
          $ = _H[1];
        switch (E) {
          case "top":
            {
              var ee = [x ? W + t / 2 : k ? W + t * 4 : W - t * 4, $ + t + 1],
                Z = [x ? W - t / 2 : k ? W + t * 4 : W - t * 4, $ + t + 1],
                le = [[b.left, k || x ? b.bottom - t : b.top], [b.right, k ? x ? b.bottom - t : b.top : b.bottom - t]];
              return [ee, Z].concat(le);
            }
          case "bottom":
            {
              var _ee = [x ? W + t / 2 : k ? W + t * 4 : W - t * 4, $ - t],
                _Z = [x ? W - t / 2 : k ? W + t * 4 : W - t * 4, $ - t],
                _le = [[b.left, k || x ? b.top + t : b.bottom], [b.right, k ? x ? b.top + t : b.bottom : b.top + t]];
              return [_ee, _Z].concat(_le);
            }
          case "left":
            {
              var _ee2 = [W + t + 1, L ? $ + t / 2 : C ? $ + t * 4 : $ - t * 4],
                _Z2 = [W + t + 1, L ? $ - t / 2 : C ? $ + t * 4 : $ - t * 4];
              return [[C || L ? b.right - t : b.left, b.top], [C ? L ? b.right - t : b.left : b.right - t, b.bottom]].concat([_ee2, _Z2]);
            }
          case "right":
            {
              var _ee3 = [W - t, L ? $ + t / 2 : C ? $ + t * 4 : $ - t * 4],
                _Z3 = [W - t, L ? $ - t / 2 : C ? $ + t * 4 : $ - t * 4],
                _le2 = [[C || L ? b.left + t : b.right, b.top], [C ? L ? b.left + t : b.right : b.left + t, b.bottom]];
              return [_ee3, _Z3].concat(_le2);
            }
        }
      }
      if (!Bt([P, M], U)) {
        if (s && !T) return A();
        if (!_ && o) {
          var H = u(S.clientX, S.clientY);
          if (H !== null && H < 0.1) return A();
        }
        Bt([P, M], Y([p, a])) ? !s && o && (r = window.setTimeout(A, 40)) : A();
      }
    };
  };
  return d.__options = {
    blockPointerEvents: n
  }, d;
}
var nt = 16,
  Ar = 24,
  Lr = 10,
  kr = 200,
  Mr = "max-content",
  Or = function Or(e, t, n) {
    var o = n.getBoundingClientRect();
    return o.top <= t && o.left <= e && o.bottom >= t && o.right >= e;
  },
  Ir = function Ir(e) {
    return !!(e && typeof e == "object" && ! /*#__PURE__*/ft(e) && e.body !== void 0);
  },
  bn = function bn(e, t) {
    var n = t / 2;
    return typeof e == "function" ? function (o) {
      return bn(e(o), t);
    } : typeof e == "object" && e.mainAxis ? _objectSpread(_objectSpread({}, e), {}, {
      mainAxis: e.mainAxis + n
    }) : e + n;
  },
  Dr = function Dr(_ref9) {
    var e = _ref9.children,
      t = _ref9.virtualElement;
    if (!e && !t) throw new Error('Tooltip: reference element not found - one of the props "children" or "virtualElement" must be defined');
    if (Tn.count(e) > 1) throw new Error("Tooltip: must have no more than one child");
    if (!t && e && ! /*#__PURE__*/ft(e)) throw new Error("Tooltip: children is not valid element");
    e && t && console.warn('Tooltip: both "children" and "virtualElement" are defined, it may cause unexpected behavior. Use only one type of reference element');
  },
  Fr = function Fr(_ref10) {
    var e = _ref10.enable,
      t = _ref10.virtualElement,
      n = _ref10.followCursor,
      o = _ref10.refs,
      r = _ref10.isOpen,
      s = _ref10.setIsOpen,
      i = _ref10.context,
      c = _ref10.showOnInteractions;
    var l = hn(),
      u = rt(function () {
        return l(_objectSpread(_objectSpread({}, i), {}, {
          onClose: function onClose() {
            return s(!1);
          }
        }));
      }, [i, l, s]),
      d = Sn(function (f) {
        var p = Or(f.clientX, f.clientY, t);
        c && u(f), p ? (r || s(!0), n && o.setReference({
          getBoundingClientRect() {
            return {
              width: 0,
              height: 0,
              x: f.clientX,
              y: f.clientY,
              left: f.clientX,
              right: f.clientX,
              top: f.clientY,
              bottom: f.clientY
            };
          }
        })) : (r && s(!1), o.setReference(t));
      }, [t, c, u, r, s, n, o]);
    me(function () {
      if (!(!e || !t)) return document.addEventListener("mousemove", d), function () {
        document.removeEventListener("mousemove", d);
      };
    }, [e, d, t]);
  },
  Nr = Q.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n  min-height: 16px;\n  font-size: 13px;\n"])));
Q.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
Q.p(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 10px;\n  line-height: 1;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  white-space: nowrap;\n  margin: 0;\n"])));
Q.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
Q(Nr)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin-bottom: 0;\n  margin-top: 8px;\n  min-height: 1em;\n  font-size: 16px;\n"])));
Q.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
Q.p(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-size: 13px;\n  line-height: 1;\n  letter-spacing: 0.1px;\n  color: ", ";\n"])), function (_ref11) {
  var e = _ref11.theme;
  return e.colors.red50;
});
be(["font-family:inherit;font-weight:400;font-size:16px;line-height:22px;", "{font-size:14px;}"], function (_ref12) {
  var e = _ref12.theme.down;
  return e("tablet");
});
var vn = "0px 1px 8px rgba(0, 0, 0, 0.17)",
  wn = "0px 4px 20px rgba(0, 0, 0, 0.07)",
  yn = "0px 4px 28px rgba(0, 0, 0, 0.14)",
  $r = be(["-webkit-filter:blur(0);will-change:filter;filter:drop-shadow(", ");"], vn);
be(["-webkit-filter:blur(0);will-change:filter;filter:drop-shadow(", ");"], wn);
var Br = be(["-webkit-filter:blur(0);will-change:filter;filter:drop-shadow(", ");"], yn);
be(["box-shadow:", ";-webkit-filter:blur(0);filter:blur(0);"], vn);
be(["box-shadow:", ";-webkit-filter:blur(0);filter:blur(0);"], wn);
be(["box-shadow:", ";-webkit-filter:blur(0);filter:blur(0);"], yn);
var _r = {
    black100: "#FFFFFF"
  },
  zr = {
    phoneSm: "320px"
  },
  Wr = "/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}main{display:block}h1{font-size:2em;margin:.67em 0}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}button,[type=button],[type=reset],[type=submit]{-webkit-appearance:button}button::-moz-focus-inner,[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner{border-style:none;padding:0}button:-moz-focusring,[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details{display:block}summary{display:list-item}template{display:none}[hidden]{display:none}";
Ln(["", " img{max-width:100%;height:auto;object-fit:contain;}body{min-width:", ";}body,button,input{font-family:", ";color:", ";}p,a,h1,h2,h3,h4,h5,input,hr,button,section,menu{margin:0;padding:0;}div,section,input,button{box-sizing:border-box;}input{outline:none;}input:-webkit-autofill,input:-webkit-autofill:hover,input:-webkit-autofill:focus,textarea:-webkit-autofill,textarea:-webkit-autofill:hover,textarea:-webkit-autofill:focus,select:-webkit-autofill,select:-webkit-autofill:hover,select:-webkit-autofill:focus{transition:background-color 100s ease-in-out 0s;}button{border:none;}"], Wr, zr.phoneSm, function (_ref13) {
  var e = _ref13.theme;
  return e.fontFamily;
}, function (_ref14) {
  var e = _ref14.theme;
  return e.colors.black10;
});
var Vr = {
    colors: _r
  },
  Hr = Q.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: ", ";\n  border-radius: 8px;\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 400;\n  letter-spacing: 0.1px;\n  text-transform: none;\n  color: ", ";\n  z-index: ", ";\n  ", "\n"])), function (_ref15) {
    var e = _ref15.theme;
    return e.colors.black100;
  }, function (_ref16) {
    var e = _ref16.theme;
    return e.colors.black10;
  }, function (_ref17) {
    var e = _ref17.theme;
    return e.zIndex.tooltip;
  }, function (_ref18) {
    var e = _ref18.$elevation;
    return e === "high" ? Br : $r;
  }),
  _t = Q.div.attrs({
    // @ts-expect-error wrong type
    "data-name": "tooltip-content"
  })(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  padding: 16px 24px;\n  white-space: pre-line;\n  overflow-wrap: break-word;\n"]))),
  Yr = Q.header(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  margin-bottom: 8px;\n"]))),
  xn = Q.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 20px;\n  letter-spacing: 0.1px;\n  padding-top: 8px;\n  border-top: 1px solid ", ";\n"])), function (_ref19) {
    var e = _ref19.theme;
    return e.colors.black95;
  }),
  zt = Q.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n\n  + ", " {\n    margin-top: 8px;\n  }\n"])), xn),
  Kr = /*#__PURE__*/Pn(function (_ref20, O) {
    var _ref21;
    var e = _ref20.content,
      t = _ref20.middleware,
      n = _ref20.children,
      _ref20$strategy = _ref20.strategy,
      o = _ref20$strategy === void 0 ? "absolute" : _ref20$strategy,
      _ref20$offset = _ref20.offset,
      r = _ref20$offset === void 0 ? Lr : _ref20$offset,
      _ref20$arrowOffset = _ref20.arrowOffset,
      s = _ref20$arrowOffset === void 0 ? Ar : _ref20$arrowOffset,
      _ref20$interactive = _ref20.interactive,
      i = _ref20$interactive === void 0 ? !0 : _ref20$interactive,
      _ref20$visible = _ref20.visible,
      c = _ref20$visible === void 0 ? !1 : _ref20$visible,
      l = _ref20.onOpen,
      u = _ref20.onClose,
      d = _ref20.onVisibilityChange,
      _ref20$placement = _ref20.placement,
      f = _ref20$placement === void 0 ? "top" : _ref20$placement,
      _ref20$maxWidth = _ref20.maxWidth,
      p = _ref20$maxWidth === void 0 ? kr : _ref20$maxWidth,
      _ref20$width = _ref20.width,
      a = _ref20$width === void 0 ? Mr : _ref20$width,
      h = _ref20.mountNode,
      _ref20$elevation = _ref20.elevation,
      g = _ref20$elevation === void 0 ? "high" : _ref20$elevation,
      _ref20$flip = _ref20.flip,
      v = _ref20$flip === void 0 ? !0 : _ref20$flip,
      _ref20$shiftOnOverflo = _ref20.shiftOnOverflow,
      w = _ref20$shiftOnOverflo === void 0 ? !0 : _ref20$shiftOnOverflo,
      _ref20$arrowProps = _ref20.arrowProps,
      y = _ref20$arrowProps === void 0 ? {} : _ref20$arrowProps,
      _ref20$mouseOnly = _ref20.mouseOnly,
      R = _ref20$mouseOnly === void 0 ? !1 : _ref20$mouseOnly,
      _ref20$showOnInteract = _ref20.showOnInteractions,
      S = _ref20$showOnInteract === void 0 ? !0 : _ref20$showOnInteract,
      _ref20$followCursor = _ref20.followCursor,
      A = _ref20$followCursor === void 0 ? !1 : _ref20$followCursor,
      P = _ref20.virtualElement,
      M = _ref20.zIndex,
      _ref20$hideOnScroll = _ref20.hideOnScroll,
      D = _ref20$hideOnScroll === void 0 ? !0 : _ref20$hideOnScroll,
      _ref20$blockPointerEv = _ref20.blockPointerEvents,
      B = _ref20$blockPointerEv === void 0 ? !1 : _ref20$blockPointerEv,
      _ = _ref20.onHover,
      V = _ref20.className,
      F = _objectWithoutProperties(_ref20, _excluded5);
    me(function () {
      Dr({
        children: n,
        virtualElement: P
      });
    }, [n, P]);
    var b = ot(null),
      _wt = wt(c),
      _wt2 = _slicedToArray(_wt, 2),
      E = _wt2[0],
      k = _wt2[1],
      C = rt(function () {
        var $ = t !== null && t !== void 0 ? t : [];
        return v && $.push(Xo(Object.assign({
          fallbackPlacements: ["top", "left", "bottom", "right"]
        }, typeof v == "object" ? v : {}))), w && $.push(Yo(typeof w == "object" ? w : {})), $;
      }, [t, v, w]),
      T = or(),
      x = _objectSpread({
        strategy: o,
        placement: f,
        middleware: [Ho(bn(r, (_ref21 = y == null ? void 0 : y.width) !== null && _ref21 !== void 0 ? _ref21 : nt))].concat(_toConsumableArray(C), [jo({
          element: b,
          padding: s
        })]),
        whileElementsMounted: function whileElementsMounted() {
          for (var _len = arguments.length, $ = new Array(_len), _key = 0; _key < _len; _key++) {
            $[_key] = arguments[_key];
          }
          return (
            // This disables using ResizeObserver https://floating-ui.com/docs/autoupdate#elementresize
            No.apply(void 0, $.concat([{
              elementResize: !1
            }]))
          );
        },
        open: E,
        onOpenChange: function onOpenChange($) {
          i && (k($), d == null || d($), $ ? l == null || l() : u == null || u());
        },
        nodeId: T
      }, F),
      _wr = wr(x),
      L = _wr.refs,
      N = _wr.context,
      I = _wr.floatingStyles,
      z = ot(null),
      _wt3 = wt(null),
      _wt4 = _slicedToArray(_wt3, 2),
      G = _wt4[0],
      U = _wt4[1],
      _Cr = Cr([ir(N, {
        enabled: i,
        mouseOnly: R,
        handleClose: S ? hn({
          blockPointerEvents: B
        }) : null
      }), Er(N, {
        enabled: i
      }), pr(N, {
        enabled: A
      }), Sr(N, {
        role: "tooltip"
      }), br(N, {
        enabled: i,
        ancestorScroll: D
      })]),
      Y = _Cr.getReferenceProps,
      H = _Cr.getFloatingProps,
      W = rt(function () {
        if (Ir(e)) {
          var $ = e.header,
            ee = e.body,
            Z = e.caption;
          return /* @__PURE__ */Ee(_t, {
            children: [$ && /* @__PURE__ */X(Yr, {
              children: $
            }), /* @__PURE__ */X(zt, {
              children: ee
            }), Z && /* @__PURE__ */X(xn, {
              children: Z
            })]
          });
        }
        return /* @__PURE__ */X(_t, {
          children: /* @__PURE__ */X(zt, {
            children: e
          })
        });
      }, [e]);
    return Fr({
      enable: !!(i && P),
      virtualElement: P,
      refs: L,
      followCursor: A,
      context: N,
      isOpen: E,
      setIsOpen: k
    }), me(function () {
      c !== void 0 && k(c);
    }, [c]), me(function () {
      return z.current && U(z.current.previousElementSibling), function () {
        return U(null);
      };
    }, []), me(function () {
      P ? L.setReference(P) : G && L.setReference(G);
    }, [G, L.setReference, L, P]), /* @__PURE__ */Ee(rr, {
      id: T,
      children: [/*#__PURE__*/ft(n) && /*#__PURE__*/An(n, Y(_objectSpread({}, n.props))), G || P ? (c || E) && /* @__PURE__ */X(ar, {
        root: h,
        children: /* @__PURE__ */Ee(Hr, _objectSpread(_objectSpread({
          ref: kn([O, L.setFloating]),
          style: _objectSpread(_objectSpread({}, I), {}, {
            maxWidth: p,
            zIndex: M,
            width: a
          }),
          $elevation: g
        }, H({
          className: V,
          onMouseEnter: _
        })), {}, {
          children: [W, /* @__PURE__ */X(er, _objectSpread({
            "data-name": "tooltip-arrow",
            ref: b,
            context: N,
            width: nt,
            height: nt / 2,
            fill: Vr.colors.black100,
            tipRadius: 1
          }, y))]
        }))
      }) : !P && /* @__PURE__ */X("span", {
        ref: z,
        style: {
          display: "none"
        }
      })]
    });
  });
export { Kr as Tooltip };